/*!
 * jQuery UI Widget-factory plugin boilerplate (for 1.8/9+)
 * Author: @addyosmani
 * Further changes: @peolanha
 * Licensed under the MIT license
 */
import {browserCheck} from '../../js/common/browserCheck.js';
require("jquery-ui/ui/widget");
require('./jquery.timecodeField.js');

var keycode = require('keycode');

if (typeof ('pad') != 'function') {
	var pad = function (number, length) {

		var str = '' + number;
		while (str.length < length) {
			str = '0' + str;
		}

		return str;
	};
}

(function ($, window, document, undefined) {

	$.widget("badmath.videoPlayer", {

		_videoPlayer: null,
		_videoDuration: 0,
		_startTc: '00:00:00',
		_endTc: '23:59:59',
		_debugEl: null,
		_statusDeferred: null,
		_showingThumbnails: false,
		_currentThumbnailPos: 0,
		_currentPos: 0,
		_videoIsLoaded: false,
		_loadingState: '',
		_initialLoad: false,
		_draggingScrubber: false,
		_wasPlayingBeforeSeek: false,
		_seeking: false,
		_buffered: null,
		_showLargePlayButtonAfterLoad: false,
		_lockToLog: false,
		_playbackStarted: false,
		_videoInPos: 0,
		_autoPlay: false,
		_canPlay: false,
		_flashLoadFinishedDfd: null,
		_html5LoadFinishedDfd: null,
		_initialSeek: false,
		_reloadingDfd: null,
		_ignoreResize: false,
		_reloadAfterClose: false,
		_maxPlayIntervalCount: 10,
		_playInterval: null,
		_seekPos: 0,
		_unloaded: false,
		_doc: null,
		_currentZoom: 0,
		_progressBarStartPos: 0,
		_progressBarDuration: 0,
		_progressBar: null,
		_clipBar: null,
		_textProgress: null,
		_playhead: null,
		_playbackControls: null,
		_clipDurationDisplay: null,
		_zoomControl: null,
		_speedControl: null,
		_volumeControl: null,
		_currentVolume: 0,
		_clipHoverInterval: null,
		_prevClip: {},
		_showingVideo: false,
		_resizeObserver: null,
		_hoverTimeout: null,

		//Options to be used as defaults
		options: {
			debug: true,
			showClipControls: true,
			disableClipTrimming: false,
			showFineTuningBar: true,
			disableAudio: false,
			fps: 29.97,
			classPrefix: '',
			file: null,
			mimeType: 'video/mp4',
			duration: 0,
			inPoint: null,
			outPoint: null,
			startOffset: 0,
			useVideoElements: function () {
				return true;
			},
			getTimecode: function (startOffset, offset, fps, ignoreFrames) {},
			getOffset: function (startOffset, timecode, fps) {},
			fineTuningRange: 30,
			flashObj: function () {
				return {
					hideControls: true,
					swf: ''
				};
			},
			flashVars: {},
			flashEventHandlerName: 'functionName',
			thumbnailPreview: true,
			showThumbnailOnPause: false,
			updateThumbnail: function (container, pos) {},
			videoBasePath: '',
			keyboardHandling: true,
			browserSupport: {
				volumeControl: true,
				fullScreen: true,
				numberInput: true
			},
			aspectRatio: 3 / 4,
			showLargePlayBuutonOnPause: false,
			lockToLogButton: false,
			autoPlay: false,
			displayLog: true,
			getCurrentLogEntry: function (offset) {},
			showLog: function () {},
			seekOnPlayThreshold: 3,
			maxZoom: 60, //number of seconds to show at max zoom.
			dragPercentage: 10, //how far left or right the playhead should be
			// to initiate a drag of the progressbar
			availableSpeeds: [{
				value: 0.25,
				text: '0.25x',
				class: 'min',
				selected: false
			}, {
				value: 0.5,
				text: '0.5x',
				class: 'low',
				selected: false
			}, {
				value: 1,
				text: '1x',
				class: 'normal',
				selected: true
			}, {
				value: 1.5,
				text: '1.5x',
				class: 'high',
				selected: false
			}, {
				value: 2,
				text: '2x',
				class: 'high',
				selected: false
			}, {
				value: 5,
				text: '5x',
				class: 'high',
				selected: false
			}, {
				value: 10,
				text: '10x',
				class: 'max',
				selected: false
			}],
			clipHoverDelay: 5000,
			clipFlagFlipDistance: 0.15,
			clipDragSnapDistance: 7,
			clipEdgePadding: 4,
			progressBarBg: [{
				zoom: {
					min: 0,
					max: 200
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x1'
			}, {
				zoom: {
					min: 200,
					max: 400
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x2'
			}, {
				zoom: {
					min: 400,
					max: 800
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x4'
			}, {
				zoom: {
					min: 800,
					max: 1600
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x8'
			}, {
				zoom: {
					min: 1600,
					max: 3200
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x16'
			}, {
				zoom: {
					min: 3200,
					max: 6400
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x32'
			}, {
				zoom: {
					min: 6400,
					max: Number.MAX_SAFE_INTEGER
				},
				image: 'lib/newPlayer/images/fine_adjust_bar-handMade.svg',
				className: 'x64'
			}],
			volumeIncrement: 0.2,
			clipSelectionContainer: null,
			minClipLength: 1,
			hoverTimeoutDuration: 3 * 1000
		},

		_log: function () {
			if (this.options.debug)
				console.log(arguments);
		},

		//Setup widget (eg. element creation, apply theming
		// , bind events etc.)
		_create: function () {
			var plugin = this;
			plugin._doc = $(document);

			var widget = $('<div/>')
				.addClass(plugin._prefixClass('player-widget'));
			plugin.element.append(
				$('<div/>').addClass(plugin._prefixClass('player-container'))
				.append(widget)
			);
			plugin._appendVideoPlayer(widget);

			if (plugin.options.useVideoElements() || !plugin.options.flashObj().hideControls) {
				plugin.element.append(plugin._createPlayerControls());
			}
			if (!plugin.options.useVideoElements() && plugin.options.flashObj().hideControls) {
				plugin.element.addClass(plugin._prefixClass('hideControls'));
			}

			if (plugin.options.debug) {
				plugin._debugEl = $('<div/>').addClass(plugin._prefixClass('debug'));
				widget.append(plugin._debugEl);
			}

			if (plugin.options.file) {
				$.when(plugin.load({
					file: plugin.options.file,
					inPoint: plugin.options.inPoint,
					outPoint: plugin.options.outPoint,
					startOffset: plugin.options.startOffset,
					duration: plugin.options.duration,
					fps: plugin.options.fps
				})).done(function () {
					plugin.setVolume(plugin.options.volume);
					plugin._updateClipDisplay();
				});
			}
			//video elements, objects break in Safari when the container changes
			//its display property

			// if (browserCheck.isSafari() && !browserCheck.isIOSHandHeld() && (!browserCheck.isIOS() || browserCheck.getIOSVersion() < 8)) {
			// 	var iosResizeTimeout = null;
			// 	var wasPlaying = false;
			// 	var pos = 0;
			// 	//var resizeTimeout = null;
			// 	$(window).on('resize', function () {
			// 		pos = plugin._currentPos;
			// 		if (!plugin._ignoreResize) {
			// 			if (plugin.isPlaying()) {
			// 				wasPlaying = true;
			// 				plugin.pause();
			// 			}
			// 			clearTimeout(iosResizeTimeout);
			// 			iosResizeTimeout = setTimeout(function () {
			// 				plugin.reloadVideo(pos);
			// 			}, 500);
			// 		} else {
			// 			plugin._reloadAfterClose = true;
			// 		}
			// 	});
			// }
			plugin._addHoverStateHandling();
			// plugin.element.on({
			// 	mouseenter: function () {

			// 		plugin._addHoverState();
			// 		plugin.element.addClass(plugin._prefixClass('hover'));
			// 		plugin.element.on('mouseleave', function (e) {
			// 			// var target = $(e.relatedTarget);

			// 			// if (target.closest(plugin._playbackControls).length) {
			// 			// 	return;
			// 			// }
			// 			$(this).off('mouseleave').removeClass(plugin._prefixClass('hover'));

			// 		});
			// 	},
			// 	touchstart: function () {
			// 		//
			// 	}
			// });
			plugin._resizeObserver = plugin._setupResizeObsever();
		},

		_setupResizeObsever: function () {
			let plugin = this;
			return new ResizeObserver((entries) => {
				if (plugin._showingThumbnails) {
					plugin._showThumbnailPreview(plugin._currentPos);
				}
				plugin._updateClipDisplay();
			});
		},

		// Destroy an instantiated plugin and clean up
		// modifications the widget has made to the DOM
		_destroy: function () {
			var plugin = this;
			console.log('destroy player!');
			this.element.removeClass(this._prefixClass('player-container'));
			this._videoPlayer.obj.remove();
			this._videoPlayer = null;
			this.element.find('.' + this._prefixClass('player-widget')).remove();
			plugin._doc.off('.videoPlayerKeys');
			plugin._resizeObserver.disconnect();
		},

		_prefixClass: function (className) {
			var plugin = this;
			var classes = className.split(' '),
				prefixed = '';
			$.each(classes, function (index, name) {
				prefixed += (prefixed ? ' ' : '') + plugin.options.classPrefix + name;
			});
			return prefixed;
		},

		_createHTMLVideoPlayer: function (container) {
			var plugin = this,
				obj = $('<video playsinline>')
				.attr('preload', 'metadata')
				//.addClass(this._prefixClass('loading'))
				.addClass(plugin._prefixClass('playerElement'));
			plugin._videoPlayer = {
				type: 'html5',
				obj: obj,
				el: obj[0]
			};

			container.append(plugin._videoPlayer.obj);
			
			//This event fires when the  external player is closed on the
			//iphone. Resume showing thumbnails at that point.
			plugin._videoPlayer.obj.on('webkitendfullscreen', function (e) {
				setTimeout(function () {
					plugin._togglePlayStateDisplay(false);
					plugin._showThumbnailPreview(plugin._currentPos);
				}, 10);
			});
			plugin._videoPlayer.obj.on('webkitbeginfullscreen', function (e) {

			});

			plugin._setupHtml5VideoEvents();
		},

		_addHoverState: function(settings) {
			let plugin = this;
			settings =$.extend({
				addTimeout: true,
				showLargeButton: false
			}, settings);

			//clearTimeout(plugin._hoverTimeout);
			plugin.element.addClass(plugin._prefixClass('hover'));
			if (settings.showLargeButton) {
				this._toggleLargePlayButton(true);
			}
			clearTimeout(plugin._hoverTimeout);
			if (settings.addTimeout) {
				plugin._hoverTimeout = setTimeout(function() {
					console.log('remove hover state');
					plugin.element.removeClass(plugin._prefixClass('hover'));
					plugin._toggleLargePlayButton(false);

					
				}, plugin.options.hoverTimeoutDuration);
			}
		},

		_addHoverStateHandling: function() {
			let plugin = this,
				touch = false;
			plugin.element/*.find(`.${hoverClass}`)*/.on({
				mouseenter: function() {
					
					if (!touch) {
					
						plugin._addHoverState({addTimeout: false});
					}
				},
				mouseleave: function(e) {
					clearTimeout(plugin._hoverTimeout);
					plugin.element.removeClass(plugin._prefixClass('hover'));
					//plugin._toggleLargePlayButton(false);
				},
				mousemove: function() {
					if (!touch) {
						if (!plugin.element.hasClass(plugin._prefixClass('hover'))) {
							
							plugin._addHoverState({addTimeout: plugin.isPlaying()});
						}
					}
				},
				touchstart: function() {

					touch = true;
				},
				click: function(e) {
					if (!$(e.target).closest('.' + plugin._prefixClass('playerDiv')).length) {
						return;
					}
					if (plugin.isPlaying()) {
						
						if (!plugin.element.hasClass(plugin._prefixClass('hover'))) {
							if (touch) {
								
								plugin._addHoverState({addTimeout: touch, showLargeButton: true});
							}
						} else {
							
							plugin.pause();
							plugin._toggleLargePlayButton(false);
							plugin._addHoverState({addTimeout: false});
							return;
						}
					} else {
						
						plugin.play();
						plugin._addHoverState({addTimeout: true});
						//plugin._addHoverState();
					}
					touch = false;
					
				}
			});
		},

		_appendVideoPlayer: function (container) {
			//test whether video is supported
			var plugin = this;
			var player = $('<div role="button"/>').addClass(this._prefixClass('playerDiv'));
				// .on('click', function () {

				// 	plugin.togglePlayState();
				// 	plugin.element.addClass(plugin._prefixClass('hover'));
				// });
			container.append(player);

			if (this.options.thumbnailPreview) {
				player.append($('<div/>').addClass(this._prefixClass('thumbnailPreview')));
			}

			player.append($('<span/>').addClass(this._prefixClass('spinnerContainer')));
			player.append($('<a/>').addClass(this._prefixClass('largePlayButton')));

			player.append($('<div/>').addClass(this._prefixClass('inClipIndicator')));
			player.append($('<span/>').addClass(this._prefixClass('statusText2')));
			player.append($('<span/>').addClass(this._prefixClass('bufferStatus')));

			if (this.options.useVideoElements()) {
				plugin._createHTMLVideoPlayer(player);
			} else if ($.flash.available) {
				var flashObj = this.options.flashObj(),
					flashContainer = $('<div/>').addClass('flashContainer');
				player.prepend(flashContainer);
				flashContainer.flash({
					swf: flashObj.swf,
					width: '100%', //flashObj.width,
					height: '100%', //flashObj.height,
					// these arguments will be passed into the flash document
					flashvars: flashObj.flashVars,
					wmode: 'opaque',
					allowFullScreen: true
				});

				this._videoPlayer = {
					type: 'flash',
					obj: flashContainer,
					properties: {
						isPlaying: false,
						muted: false
					}
				};
			} else {
				this._trigger("error", event, {
					message: 'Video is not supported.'
				});
			}
		},

		_keyIsModified(e) {
			return e.shiftKey || e.ctrlKey || e.altKey;
		},

		_bindKeys: function () {
			var plugin = this;

			plugin._doc.on('keydown.videoPlayerKeys', function (e) {
				if (e.target.nodeName != "INPUT" && e.target.nodeName != 'TEXTAREA') {
					
					switch (e.keyCode) {
					case keycode('i'): //i
						if (e.shiftKey) {
							plugin.jumpToClip('in');
						} else if (!plugin._keyIsModified(e)) {
							plugin.setIn();
						}
						break;
					case keycode('o'): //o
						if (e.shiftKey) {
							plugin.jumpToClip('out');
						} else if (!e.ctrlKey) {
							plugin.setOut();
						}
						break;
					case keycode('right'): //right Arrow
						e.preventDefault();
						if (e.altKey) {
							plugin.step(1 / plugin.options.fps);
						} else if (e.ctrlKey) {
							plugin.step(10);
						} else if (!plugin._keyIsModified(e)) {
							plugin.step(1);
						}
						break;
					case keycode('left'): //left Arrow
						e.preventDefault();
						if (e.altKey) {
							plugin.step(-1 / plugin.options.fps);
						} else if (e.ctrlKey) {
							plugin.step(-10);
						} else if (!plugin._keyIsModified(e)) {
							plugin.step(-1);
						}
						break;
					case keycode(' '): //space
						if (!plugin._keyIsModified(e)) {
							e.preventDefault();
							if (plugin.isPlaying()) {
								plugin.pause();
							} else {
								plugin.play();
							}
						}
						break;
					case keycode('+'): //+ zoom in
					case keycode('numpad +'):
						if (e.altKey) {
							plugin._zoomControl.find('.zoomIn').trigger('click');
						}
						break;
					case keycode('-'): //- zoom in
					case keycode('numpad -'):
						if (e.altKey) {
							plugin._zoomControl.find('.zoomOut').trigger('click');
						}
						break;
					case keycode('0'): //0 reset zoom
					case keycode('numpad 0'):
						if (e.altKey) {
							plugin.setZoom(0);
						}
						break;
					case keycode('z'): //z
						if (e.shiftKey) {
							plugin.zoomToClip();
						} else if (e.ctrlKey) {
							if (plugin._prevClip) {
								plugin.setClip(plugin._prevClip.inPoint, plugin._prevClip.outPoint);
							}
						}
						break;
					case keycode('p'): //p
						if (e.ctrlKey) {
							plugin._textProgress.find('input').first().focus();
							e.preventDefault();
						}
						break;
					case keycode('home'): //home
						if (!plugin._keyIsModified(e)) {
							plugin.seek(0);
							e.preventDefault();
						}
						break;
					case keycode('end'): //end
						if (!plugin._keyIsModified(e)) {
							plugin.seek(plugin._videoDuration);
							e.preventDefault();
						}
						break;
					case keycode('j'): //j
						if (!plugin._keyIsModified(e)) {
							plugin.decreaseSpeed();
						}
						break;
					case keycode('k'): //k
						if (!plugin._keyIsModified(e)) {
							plugin.pause();
						}
						break;
					case keycode('l'): //l
						if (!plugin._keyIsModified(e)) {
							if (!plugin.isPlaying()) {
								plugin.play();
							} else {
								plugin.increaseSpeed();
							}
						}
						break;
					case keycode('n'): //n
						if (e.shiftKey) {
							plugin.setNormalSpeed();
						}
						break;
					case keycode('f'): //f
						if (!plugin._keyIsModified(e)) {
							plugin.toggleFullScreen();
						}
						break;
					case keycode('v'): //v
						if (!plugin._keyIsModified(e)) {
							plugin.toggleVolumeMode();
						}
						break;
					case keycode('s'): //s
						if (!plugin._keyIsModified(e)) {

							plugin.toggleSpeedMode();
						}
						break;
					}

				}

			});
		},

		_updateClipDisplay: function () {
			var plugin = this,
				outPoint = plugin.options.outPoint ? plugin.options.outPoint : plugin._videoDuration,
				timecodeIn = plugin.options.getTimecode(plugin.options.startOffset, plugin.options.inPoint,
					plugin.options.fps, true),
				timecodeOut = plugin.options.getTimecode(plugin.options.startOffset, outPoint, plugin.options
					.fps,
					true),
				clipDuration = outPoint - plugin.options.inPoint,
				innerBarWidth = $('.' + plugin._prefixClass('innerBar')).width(),
				leftRatio = plugin.options.inPoint / plugin._videoDuration,
				widthRatio = clipDuration / plugin._videoDuration,
				barLeft = plugin._progressBar.find('.innerBar').position().left,
				progressBarWidth = plugin._progressBar.width(),
				left = innerBarWidth * leftRatio + plugin.options.clipEdgePadding,
				width = innerBarWidth * widthRatio - 2 * plugin.options.clipEdgePadding;
			plugin._updateTimecodeTextField('inPoint', timecodeIn, true /*force update*/ );
			plugin._updateTimecodeTextField('outPoint', timecodeOut, true /*force update*/ );

			plugin._updateTimecodeTextFieldMinMax('inPoint', plugin._startTc, timecodeOut);
			plugin._updateTimecodeTextFieldMinMax('outPoint', timecodeIn, plugin._endTc);
			plugin._clipDurationDisplay.text(plugin.options.getTimecode(0, clipDuration,
				plugin.options.fps, true));
			if (clipDuration >= plugin._videoDuration) {
				plugin.element.addClass('fullClip');
			} else {
				plugin.element.removeClass('fullClip');
			}

			// plugin._clipBar.css({
			// 	left:  left + '%',
			// 	width: width + '%',
			// });

			plugin._clipBar.css({
				left: left + 'px',
				width: width + 'px',
			}).data('ratio', {
				left: leftRatio,
				width: widthRatio
			});
			plugin._progressBar.find('.' + plugin._prefixClass('before')).css('width', left);
			plugin._progressBar.find('.' + plugin._prefixClass('after')).css('width', innerBarWidth - (
				left + width));

			plugin._clipBar.removeClass('flipLeft flipRight narrow overlap');
			var visibleLeft = left + barLeft,
				flipPixelDistance = plugin.options.clipFlagFlipDistance * progressBarWidth;
			if (visibleLeft > 0 && visibleLeft < flipPixelDistance) {
				plugin._clipBar.addClass('flipLeft');
			}
			if (visibleLeft + width < progressBarWidth &&
				visibleLeft + width > progressBarWidth - flipPixelDistance) {
				plugin._clipBar.addClass('flipRight');
			}

			if (width < flipPixelDistance) {
				plugin._clipBar.addClass('narrow');
			}
			if (!plugin._clipBar.find('.inHandle').data('origWidth')) {
				plugin._clipBar.find('.inHandle').data('origWidth', plugin._clipBar.find('.inHandle').width());
			}
			if (plugin._clipBar.find('.outHandle').offset().left < plugin._clipBar.find('.inHandle').offset()
				.left + plugin._clipBar.find('.inHandle').data('origWidth')) {
				plugin._clipBar.addClass('overlap');
			}

		},

		_createClipBar: function () {
			var plugin = this;
			plugin._clipBar = $('<div/>').addClass(plugin._prefixClass('clip'));

			function updateClip(whichEnd, pixelPos, suppressCallback) {
				var forceRedraw = false;
				if (suppressCallback === undefined) {
					suppressCallback = false;
					forceRedraw = true;
				}

				if (plugin.options.disableClipTrimming) {
					return;
				}

				var pos = pixelPos - plugin._progressBar.offset().left;

				if (Math.abs(pos - plugin._playhead.position().left) < plugin.options.clipDragSnapDistance) {
					pos = plugin._playhead.position().left;
				}

				var percentage = Math.min(1, Math.max(0, pos / plugin._progressBar.width())),
					realPos = plugin._progressBarStartPos + percentage * plugin._progressBarDuration;

				$.when(plugin.setEndPoint(whichEnd, realPos, suppressCallback, forceRedraw)).done(function () {
					plugin.seek(pos, false, false);
				});
				// switch (whichEnd) {
				// case 'in':
				// 	$.when(plugin.setIn(realPos, suppressCallback, forceRedraw)).done(function (pos) {
				// 		plugin.seek(pos, false, false);
				// 	});
				// 	break;
				// case 'out':
				// 	$.when(plugin.setOut(realPos, suppressCallback, forceRedraw)).done(function (pos) {
				// 		plugin.seek(pos, false, false);
				// 	});
				// 	break;
				// }

			}

			plugin._clipBar.append($('<div/>')
				.addClass(plugin._prefixClass('clipHandle inHandle'))
				.data('whichEnd', 'in')
				.append(
					plugin._createClipPointField('inPoint',
						plugin.setIn, 'Clip In Point')
				)
			).append($('<div/>')
				.addClass(plugin._prefixClass('clipHandle outHandle'))
				.data('whichEnd', 'out')
				.append(
					plugin._createClipPointField('outPoint',
						plugin.setOut, 'Clip Out Point')
				)

			);

			plugin._clipBar.on({
				mousedown: function (e) {
					var handle = $(this);
					if (plugin.options.disableClipTrimming) {
						return;
					}
					if ($(e.target).is('.tcField:focus')) {
						return;
					}

					e.stopPropagation();

					var offset = e.pageX - (handle.offset().left + handle.width() / 2);
					var whichEnd = handle.data('whichEnd');
					if (plugin.options.debug) {
						plugin._debugEl.text('start clip');
					}
					plugin._prevClip = {
						inPoint: plugin.options.inPoint,
						outPoint: plugin.options.outPoint
					};
					plugin.pause();
					plugin._progressBar.addClass('draggingClip');
					plugin._doc.one('mouseup', function (e) {
						updateClip(whichEnd, e.pageX - offset);
						plugin._doc.off('.scrubClip');
						plugin._progressBar.removeClass('draggingClip');
						plugin.seek(plugin._currentPos, false, false);
					});

					plugin._doc.on('mousemove.scrubClip', function (e) {
						updateClip(whichEnd, e.pageX - offset, true);
					});
					if (!$(e.target).closest('.tcTextField').length) {
						return false;
					}
				},
				touchstart: function (e) {
					if (plugin.options.disableClipTrimming) {
						return;
					}
					let handle = $(this),
						whichEnd = handle.data('whichEnd'),
						touchstartPos = e.originalEvent.changedTouches[0].pageX,
						touchOffset = touchstartPos - handle.offset().left;
					
					plugin._clipBar.addClass('hover');
					e.stopPropagation();
					e.preventDefault();
					
					plugin._progressBar.addClass('draggingClip');
					plugin._doc.one('touchend.scrubClip', function (e) {
						plugin._doc.off('.scrubClip');
						if (Math.abs(e.originalEvent.changedTouches[0].pageX - touchstartPos) < 5) {
							plugin._progressBar.removeClass('draggingClip');
							handle.find('.tcTextField').trigger('showTimecodeOverlay');
							return;
						}
						updateClip(whichEnd, e.originalEvent.changedTouches[0].pageX - touchOffset);
						plugin.seek(plugin._currentPos, false, false);
						plugin._progressBar.removeClass('draggingClip');
					});

					plugin._doc.on('touchmove.scrubClip', function (e) {
						e.preventDefault();

						updateClip(whichEnd, e.originalEvent.changedTouches[0].pageX - touchOffset, true /* suppress callback */ );
						return false;

					});
					return false;
				},
			}, '.' + plugin._prefixClass('clipHandle'));

			plugin._clipBar.on({
				touchstart: function (e) {
					if (plugin.options.disableClipTrimming) {
						return;
					}
					plugin._clipBar.addClass('hover');
				},
				mouseenter: function () {

					plugin._clipBar.addClass('hover');
					plugin._clipBar.on('mouseleave', function () {
						clearInterval(plugin._clipHoverInterval);
						plugin._clipHoverInterval = setInterval(function () {
							if (!plugin._clipBar.find('.tcField.focused').length &&
								!plugin._progressBar.hasClass('draggingClip')) {
								clearInterval(plugin._clipHoverInterval);
								plugin._clipBar.removeClass('hover');
								plugin._clipBar.off('mouseleave');
							}
						}, plugin.options.clipHoverDelay);
					});
				}
			});

			return plugin._clipBar;
		},

		_createJumpToClipControls: function () {
			var plugin = this;
			return $('<div/>')
				.addClass(plugin._prefixClass('jumpToClip'))
				.append($('<button/>')
					.addClass(plugin._prefixClass('jumpToClipIn'))
					.attr('title', 'Jump to IN point (Shift-I)')
					.on('click touchstart', function () {
						plugin.jumpToClip('in');
					})
				).append($('<button/>')
					.addClass(plugin._prefixClass('jumpToClipOut'))
					.attr('title', 'Jump to OUT point (Shift-O)')
					.on('click touchstart', function () {
						plugin.jumpToClip('out');
					})
				);

		},

		_updateInnerBar: function (startPos, duration, animate, playheadAlignment) {
			var dfd = new $.Deferred(),
				plugin = this;
			animate = animate === undefined ? false : animate;
			plugin._progressBarStartPos = startPos;
			plugin._progressBarDuration = duration === undefined ? plugin._progressBarDuration :
				duration;
			plugin._log('progress bar start:' + plugin._progressBarStartPos + ' currentPos:' + plugin._currentPos);
			//plugin._log("Progress Bar Start Pos: " + plugin._progressBarStartPos);
			//plugin._log("Current Pos: " + plugin._currentPos);
			//plugin._log("Progress Bar Duration: " + plugin._progressBarDuration);
			var width = (1 / (plugin._progressBarDuration / plugin._videoDuration)) * 100;
			var left = width * (plugin._progressBarStartPos / plugin._videoDuration);
			if (width - left < 100) {
				left = width - 100;
				plugin._progressBarStartPos = left / width * plugin._videoDuration;
				//plugin._log("shifted left Progress Bar Start Pos: " + plugin._progressBarStartPos);
			}
			//plugin._log(width - left);
			//plugin._log(plugin._progressBarDuration/plugin._videoDuration, width, left);
			if (animate) {
				plugin._progressBar.find('.innerBar').addClass('animate');
				plugin._playhead.addClass('animate');
			}
			plugin._progressBar.find('.innerBar').one('transitionend', function () {
				$(this).removeClass('animate');
				plugin._playhead.removeClass('animate');
				plugin._log('transitionend');
				dfd.resolve();
			});
			plugin._progressBar.find('.innerBar').css({
				width: width + '%',
				left: -left + '%'
			});

			$.each(plugin.options.progressBarBg, function (index, bg) {
				if (width >= bg.zoom.min && width < bg.zoom.max) {
					plugin._progressBar.find('.bg.' + bg.className).addClass('visible');
				} else {
					plugin._progressBar.find('.bg.' + bg.className).removeClass('visible');
				}
			});
			// if (width < 1000) {
			// 	plugin._progressBar.removeClass('x2 x4');
			// } else if (width < 4000) {
			// 	plugin._progressBar.removeClass('x4').addClass('x2');
			// } else {
			// 	plugin._progressBar.addClass('x4');
			// }

			if (plugin.options.inPoint < plugin._progressBarStartPos) {
				plugin.element.find('.jumpToClipIn').addClass('offscreen left').removeClass('right');
			} else if (plugin.options.inPoint > plugin._progressBarStartPos + plugin._progressBarDuration) {
				plugin.element.find('.jumpToClipIn').addClass('offscreen right').removeClass('left');
			} else {
				plugin.element.find('.jumpToClipIn').removeClass('offscreen right left');
			}

			if (plugin.options.outPoint < plugin._progressBarStartPos) {
				plugin.element.find('.jumpToClipOut').addClass('offscreen left').removeClass('right');
			} else if (plugin._progressBarDuration && plugin.options.outPoint > Math.ceil(plugin._progressBarStartPos +
					plugin._progressBarDuration)) {
				plugin.element.find('.jumpToClipOut').addClass('offscreen right').removeClass('left');
			} else {
				plugin.element.find('.jumpToClipOut').removeClass('offscreen right left');
			}
			plugin._updateClipDisplay();
			plugin._updatePlayheadPosition(plugin._currentPos, false, playheadAlignment);
			if (!animate) {
				dfd.resolve();
			}
			return dfd.promise();
		},

		_updatePos: function (pixelPos, play, dragging) {
			var plugin = this;
			var pageX = pixelPos;
			pixelPos -= plugin._progressBar.offset().left;
			var percentage = Math.min(1, Math.max(0, pixelPos / plugin._progressBar.width()));
			//var timePos = percentage * plugin._videoDuration;

			var timePos = plugin._progressBarStartPos + percentage * plugin._progressBarDuration;
			if (dragging && percentage < plugin.options.dragPercentage / 100 && timePos < plugin._currentPos) {
				plugin._updateInnerBar(Math.max(0, plugin._progressBarStartPos - plugin.options.dragPercentage *
					plugin._progressBarDuration / 100));
			} else if (percentage > (100 - plugin.options.dragPercentage) / 100 && timePos > plugin._currentPos) {
				plugin._updateInnerBar(Math.min(
					plugin._videoDuration - plugin._progressBarDuration,
					plugin._progressBarStartPos + plugin.options.dragPercentage * plugin._progressBarDuration /
					100
				));
			}

			//var tc = plugin.options.getTimecode(plugin.options.startOffset, timePos, this.options.fps,
			//	true);
			//plugin.seekTimecode(tc, play);
			plugin.seek(timePos, play);
		},

		_createProgressBar: function () {
			var plugin = this;
			plugin._playhead = $('<div/>').addClass(plugin._prefixClass('playHead'))
				.on('mouseenter', function () {
					if (plugin._currentPos >= plugin.options.inPoint && plugin._currentPos <= plugin.options.outPoint)
						plugin._clipBar.trigger('mouseenter');
					$(this).one('mouseleave', function () {
						plugin._clipBar.trigger('mouseleave');
					});
				});
			plugin._progressBar = $('<div/>')
				.addClass(plugin._prefixClass('progressBar'))
				.append($('<div/>').addClass(plugin._prefixClass('innerContainer'))
					.append($('<div/>').addClass(plugin._prefixClass('innerBar'))
						.append(function () {
							var div = $('<div/>');
							$.each(plugin.options.progressBarBg, function (index, bg) {
								div.append(
									$('<div/>')
									.addClass(plugin._prefixClass('bg ' + bg.className +
										(index === 0 ? ' visible' : ''))).css({
										'background-image': 'url(\'' + bg.image + '\')'
									})
								);
							});
							return div.html();
						})
						.append($('<canvas/>').addClass(plugin._prefixClass('buffered')))
						.append($('<div/>').addClass(plugin._prefixClass('outsideClip before')))
						.append(plugin._createClipBar())
						.append($('<div/>').addClass(plugin._prefixClass('outsideClip after')))
					)

				)
				.append(plugin._playhead);

			var touched = false;
			plugin._progressBar.on({
				mousedown: function (e) {
					var isPlaying = plugin.isPlaying();

					if (touched) {
						return false;
					}
					if ($(e.target).closest('.tcTextField').length) {
						return;
					}
					plugin._playhead.focus();
					plugin._progressBar.find('input').removeClass('focused');

					if (plugin.isPlaying()) {
						plugin.pause();
					}
					plugin.element.find('.' + plugin._prefixClass('currentPos') + ' .' + plugin._prefixClass(
						'tcField')).blur();
					e.preventDefault();
					plugin._draggingScrubber = true;
					plugin._wasPlayingBeforeSeek = plugin.isPlaying();

					//if (!plugin._showingThumbnails) {
					//	plugin.pause(false);
					//	plugin._toggleLoadingStateDisplay(true);
					//}
					plugin._doc.one('mouseup', function (e) {

						plugin._draggingScrubber = false;
						plugin._updatePos(e.pageX, isPlaying, false);
						plugin._doc.off('.scrub');
					});

					plugin._doc.on('mousemove.scrub', function (e) {
						plugin._updatePos(e.pageX, false, true);
					});
					return false;
				},
				touchstart: function (e) {
					if ($(e.target).closest('.tcTextField').length) {
						return;
					}
					// plugin.element.addClass(plugin._prefixClass('hover'));
					// plugin._doc.one('touchstart', function(e) {
					// 	var target = $(e.target);
					// 	if (plugin._progressBar.has(target) || 
					// 		plugin._playbackControls.has(target)) {
					// 		return;
					// 	}
					// 	plugin.element.removeClass(plugin._prefixClass('hover'));

					// });
					touched = true;
					var isPlaying = plugin.isPlaying();
					plugin.pause();
					e.preventDefault();
					plugin._draggingScrubber = true;
					plugin._wasPlayingBeforeSeek = plugin.isPlaying();

					plugin._doc.one('touchend', function (evt) {
						touched = false;
						plugin._draggingScrubber = false;
						plugin._updatePos(
							evt.originalEvent.changedTouches[0].pageX,
							isPlaying, false);
						plugin._doc.off('.scrub');
					});

					plugin._doc.on('touchmove.scrub', function (e) {
						e.preventDefault();
						if (plugin.options.debug) {
							plugin._debugEl.text('move ' + e.originalEvent.changedTouches[0].pageX);
						}

						plugin._updatePos(
							e.originalEvent.changedTouches[0].pageX, false, true);

					});
					return false;
				}

			});

			return plugin._progressBar;
		},

		_createProgressBarOverlay: function () {
			var plugin = this;
			var div = $('<div/>').addClass(plugin._prefixClass('progressBarOverlay'));
			var touched = false;
			div.on({
				mousedown: function (e) {

					if (touched) {
						return false;
					}

					var isPlaying = plugin.isPlaying();
					plugin.element.find('.' + plugin._prefixClass('currentPos') + ' .' + plugin._prefixClass(
						'tcField')).blur();
					e.preventDefault();
					plugin._draggingScrubber = true;
					plugin._wasPlayingBeforeSeek = plugin.isPlaying();

					//if (!plugin._showingThumbnails) {
					//	plugin.pause(false);
					//	plugin._toggleLoadingStateDisplay(true);
					//}
					plugin._doc.one('mouseup', function (e) {

						plugin._draggingScrubber = false;
						plugin._updatePos(e.pageX, isPlaying, false);
						plugin._doc.off('.scrub');
					});

					plugin._doc.on('mousemove.scrub', function (e) {
						plugin._updatePos(e.pageX, false, true);
					});
					return false;
				},
				touchstart: function (e) {
					touched = true;
					var isPlaying = plugin.isPlaying();
					e.preventDefault();
					plugin._draggingScrubber = true;
					plugin._wasPlayingBeforeSeek = plugin.isPlaying();

					plugin._doc.one('touchend', function (evt) {
						touched = false;
						plugin._draggingScrubber = false;
						plugin._updatePos(evt.originalEvent.changedTouches[0].pageX,
							isPlaying, false);
						plugin._doc.off('.scrub');
					});

					plugin._doc.on('touchmove.scrub', function (e) {
						e.preventDefault();
						if (plugin.options.debug) {
							plugin._debugEl.text('move ' + e.originalEvent.changedTouches[0].pageX);
						}

						plugin._updatePos(e.originalEvent.changedTouches[0].pageX,
							true, true);

					});
					return false;
				},

			});
			return div;
		},

		_createClipPointField: function (className, onChange, label) {
			var plugin = this;
			var div = $('<div/>')
				.addClass(this._prefixClass('pointField'))
				.addClass(this._prefixClass(className))
				.append(this._createTimecodeTextField(
					className + 'Pos', true, onChange, label));
			return div;
		},

		_createZoomControl: function () {
			var plugin = this,
				zoomControl = $('<div/>').addClass(this._prefixClass('zoomControl')),
				zoomBG = $('<div/>').addClass(this._prefixClass('bg')),
				bar = $('<div/>').addClass(this._prefixClass('bar')),
				barFill = $('<div/>').addClass(this._prefixClass('barFill')),
				pointer = $('<div/>').addClass(this._prefixClass('pointer')),
				zoomOut = $('<span/>').addClass('button zoomOut').attr('title', 'Zoom timeline out (Alt -)'),
				zoomIn = $('<span/>').addClass('button zoomIn').attr('title', 'Zoom timeline in (Alt +)');

			zoomControl.append(zoomOut).append(zoomBG).append(bar).append(pointer).append(zoomIn);
			bar.append(barFill);

			function getZoom(pixelPos) {
				var pos = pixelPos - zoomControl.offset().left,
					width = zoomControl.width();
				if (pos > width) {
					pos = width;
				}
				if (pos < 0) {
					pos = 0;
				}
				pointer.css({
					left: pos + 'px'
				});
				return pos / width;
			}

			function roundToQuarter(num, func) {
				return Math.max(0, Math.min(1, (func(num * 4) / 4)));
			}

			zoomOut.click(function () {
				if( !plugin._zoomControl || !plugin._zoomControl.hasClass('disabled'))
					plugin.setZoom(roundToQuarter(plugin._currentZoom - 0.25, Math.ceil));
			});
			zoomIn.click(function () {
				if( !plugin._zoomControl || !plugin._zoomControl.hasClass('disabled'))
					plugin.setZoom(roundToQuarter(plugin._currentZoom + 0.25, Math.floor));
			});
			zoomControl.on({
				mousedown: function (e) {
					if( plugin._zoomControl && plugin._zoomControl.hasClass('disabled')) {
						return;
					}
					if ($(e.target).is('.button')) {
						return;
					}
					if (plugin._videoDuration < plugin.options.maxZoom) {
						return;
					}
					e.preventDefault();
					plugin._doc.on({
						mouseup: function () {
							plugin._doc.off('mousemove.setZoom');
							//var zoom = getZoom(e.pageX);
							//plugin.setZoom(zoom);
						},
						'mousemove.setZoom': function (e) {

							var zoom = getZoom(e.pageX);
							plugin.setZoom(zoom);

						}
					});
				},
				touchstart: function (e) {
					//plugin.pause();
					if ($(e.target).is('.button')) {
						
						return;
					}
					if( plugin._zoomControl && plugin._zoomControl.hasClass('disabled')) {
						return;
					}
					if (plugin._videoDuration < plugin.options.maxZoom) {
						return;
					}
					e.preventDefault();
					plugin._doc.on({
						'touchend.setZoom': function (e) {
							plugin._doc.off('touchmove.setZoom touchend.setZoom');
							var zoom = getZoom(e.originalEvent.changedTouches[0].pageX);
							plugin.setZoom(zoom);
						},
						'touchmove.setZoom': function (e) {
							e.preventDefault();
							var zoom = getZoom(e.originalEvent.changedTouches[0].pageX);
							plugin.setZoom(zoom);

						}
					});
				},
				click: function (e) {
					if( plugin._zoomControl && plugin._zoomControl.hasClass('disabled')) {
						return;
					}
					if ($(e.target).is('.button')) {
						return;
					}
					if (plugin._videoDuration < plugin.options.maxZoom) {
						return;
					}
					var zoom = getZoom(e.pageX);
					plugin.setZoom(zoom);
				}
			});
			return zoomControl;
		},

		_createSelectionControl: function () {
			var plugin = this;
			var selectionDiv = $('<div/>').addClass(plugin._prefixClass('clipSelection'));

			selectionDiv.append(
				plugin._createClipPointField('inPoint',
					plugin.setIn, 'Clip In Point')
			).append(plugin._createClipPointField('outPoint',
				plugin.setOut, 'Clip Out Point')).append(plugin._createClipDurationDisplay());

			return selectionDiv;
		},

		_createClipDurationDisplay: function () {
			var plugin = this;
			plugin._clipDurationDisplay = $('<span/>').addClass(plugin._prefixClass('clipDuration'));
			return plugin._clipDurationDisplay;
		},

		_createFineTuningBar: function () {
			var plugin = this;
			var div = $('<div/>').addClass(this._prefixClass('fineTuningBar'));

			var pointer = $('<div/>').addClass(this._prefixClass('pointer'));
			div.append(pointer);

			function updatePos(pixelPos, startTime) {
				var pos = pixelPos - div.offset().left;
				var width = div.width();
				if (pos > width) {
					pos = width;
				}
				if (pos < 0) {
					pos = 0;
				}
				pointer.css({
					left: pos + 'px'
				});

				var newPos = Math.max(0, Math.min(Math.floor(plugin._videoDuration), startTime + plugin.options
					.fineTuningRange * (pos - width / 2) / width));
				if (plugin.options.debug) {
					plugin._debugEl.text(pos + ' ' + div.width() / 2);
				}
				//plugin.seek(newPos, false);
				var tc = plugin.options.getTimecode(plugin.options.startOffset, newPos, plugin.options.fps,
					true);
				plugin.seekTimecode(tc, false);
			}
			div.on({
				mousedown: function (e) {
					plugin.pause();
					e.preventDefault();
					$.when(plugin.getCurrentTime()).done(function (startTime) {
						plugin._doc.one('mouseup', function (e) {
							let mouseDown = false;
							pointer.css({
								left: ''
							});
							plugin._doc.off('mousemove.finetuning');
						});
						plugin._doc.on('mousemove.finetuning', function (e) {
							updatePos(e.pageX, startTime);

						});
					});
					return false;
				},
				touchstart: function (e) {
					plugin.pause();
					e.preventDefault();
					$.when(plugin.getCurrentTime()).done(function (startTime) {
						plugin._doc.one('touchend', function (e) {
							let mouseDown = false;
							pointer.css({
								left: ''
							});
							plugin._doc.off('touchmove.finetuning');
						});
						plugin._doc.on('touchmove.finetuning', function (e) {
							e.preventDefault();
							updatePos(e.originalEvent.changedTouches[0].pageX, startTime);
						});
					});
					return false;
				}
			});

			return div;

		},

		_createSpeedControl: function () {
			var plugin = this,
				speedControl = $('<div/>').append($('<a/>').addClass('selection'))
				.addClass(plugin._prefixClass('speedControl'))
				.attr('title', 'Playback Speed (S)');

			speedControl.on({
				touchstart: function (e) {
					e.stopPropagation();
					speedControl.find('.options').removeClass('hidden');
					plugin._clipBar.removeClass('hover');
					plugin._doc.one('touchstart', function () {
						speedControl.find('.options').addClass('hidden');
					});
				},
				mouseenter: function (e) {
					e.stopPropagation();
					plugin.showSpeedControl();
				},
				mouseleave: function (e) {
					if ($.contains(speedControl, $(e.relatedTarget))) {
						return;
					}
					plugin.hideSpeedControl();
				}
			});
			speedControl.append(function () {
				var options = $('<div/>')
					.addClass('options hidden');
				$.each(plugin.options.availableSpeeds, function (index, speed) {
					options.append($('<div/>')
						.data('speed', speed)
						.text(speed.text)
						.addClass('option')
						.addClass('speed_' + speed.text.replace('.', '_'))
						.addClass(speed.selected ? 'selected' : '')
					);
					if (speed.selected) {
						//delay this until after this event handler so
						//plugin._speedControl is defined when it runs.
						setTimeout(function () {
							plugin.setSpeed(speed);
						}, 0);
					}
				});
				options.on('click', '.option', function (e) {
					e.stopPropagation();
					$(this).siblings().removeClass('selected');
					$(this).addClass('selected');
					plugin.setSpeed($(this).data('speed'));
					speedControl.find('.options').addClass('hidden');
				});
				return options;
			});
			return speedControl;
		},

		_createVolumeControl: function () {
			var plugin = this,
				mouseDown = false,
				volumeControl = $('<div/>').addClass(this._prefixClass('volumeControl')),
				volumeBar = $('<div/>').addClass(this._prefixClass('volumeBar'))
				.append($('<div/>').addClass(this._prefixClass('volumeLevelBG')))
				.append($('<div/>').addClass(this._prefixClass('volumeLevel')));

			volumeControl
				.append(volumeBar)
				.append($('<span/>')
					.addClass(this._prefixClass('volumeButton'))
					.attr('title', 'Volume (V)')
					.on('click', function () {
						if (volumeBar.is(':visible')) {
							plugin.mute();
						}
					})
				).on({
					mouseenter: function () {
						plugin.showVolumeControl();
					},
					mouseleave: function (e) {
						if ($.contains(volumeControl, $(e.relatedTarget))) {
							return;
						}
						plugin.hideVolumeControl(false);

					}
				});
			volumeBar.on({

				mousedown: function (e) {
					e.preventDefault();
					if (plugin.options.disableAudio) {
						return;
					}
					var volumeLevelBG = $(this).find('.' + plugin._prefixClass('volumeLevelBG'));
					var bottomPos = volumeLevelBG.offset().top + volumeLevelBG.height();
					var height = volumeLevelBG.height();

					mouseDown = true;
					plugin._doc.on('mousemove.setVolume', function (e) {
						var vol = Math.min(1, Math.max(0, (bottomPos - e.pageY) / height));
						plugin.setVolume(vol);

					});
					plugin._doc.one({
						mouseup: function (e) {
							var vol = Math.min(1, Math.max(0, (bottomPos - e.pageY) / height));
							plugin.setVolume(vol);
							plugin._doc.off('.setVolume');
							mouseDown = false;
						},
						touchend: function (e) {
							var pos = e.originalEvent.touches[0].pageY;
							var vol = Math.min(1, Math.max(0, Math.abs(bottomPos - e.pageY) / height));
							plugin.setVolume(vol);
							plugin._doc.off('.setVolume');
							mouseDown = false;

						}
					});
					return false;
				},
				mouseleave: function (e) {
					if (mouseDown || $.contains(volumeControl, $(e.relatedTarget))) {
						return;
					}
					plugin.hideVolumeControl();
				}
			});
			return volumeControl;
		},

		_createPlayerControls: function () {
			var plugin = this;
			var controlsDiv = $('<div/>').addClass(plugin._prefixClass('controls'));

			plugin._textProgress = $('<div/>').addClass(plugin._prefixClass('textProgress'))
				.append(plugin._createTimecodeTextField('currentPos', true, plugin.seekTimecode,
					'Current Play Position', true).on('touchstart', function(e) {
						e.preventDefault();
						e.stopPropagation();
						$(this).trigger('showTimecodeOverlay');
						return false;
					}))
				//.append('/')
				.append(plugin._createTimecodeTextField('duration', false));
			controlsDiv.append(plugin._textProgress);

			controlsDiv.append(plugin._createProgressBar())
				.append(plugin._createPlaybackControls())
				.append(plugin._createJumpToClipControls())
				.append(plugin._zoomControl = plugin._createZoomControl());

			controlsDiv.append(plugin._zoomControl);
			if (plugin.options.clipSelectionContainer) {
				plugin.options.clipSelectionContainer.prepend(plugin._createSelectionControl());
			} else {
				controlsDiv.append(plugin._createSelectionControl());
			}

			if (plugin.options.displayLog) {
				controlsDiv.append($('<div/>')
					.addClass(this._prefixClass('logDisplay'))
					.on('click', function (e) {
						e.stopPropagation();
						plugin.options.showLog();
						return false;
					})
				);
			}

			if (plugin.options.lockToLogButton) {
				controlsDiv.append($('<span/>')
					.addClass(plugin._prefixClass('lockToLogButton'))
					.on('click', function () {
						if (plugin.element.hasClass(plugin._prefixClass('lockedToLog'))) {
							plugin.element.removeClass(plugin._prefixClass('lockedToLog'));
						} else {
							plugin.element.addClass(plugin._prefixClass('lockedToLog'));
						}
						$.when(plugin.getCurrentTime()).done(function (time) {
							plugin._updatePlayheadPosition(time);
						});
					})
				);
			}

			//controlsDiv.append($('<a/>').addClass('button save').text('Save changes!'));
			return controlsDiv;

		},

		_createPlaybackControls: function () {
			var plugin = this;
			plugin._playbackControls = $('<div/>')
				.addClass(plugin._prefixClass('playbackControls'))
				.on('touchstart', function (e) {
					e.stopPropagation();
				});
			plugin._playbackControls.append($('<span/>')
				.addClass(plugin._prefixClass('playButton'))
				.attr('title', 'Play/Pause (Space)')
				.on({
					'click': function (e) {
						e.stopPropagation();
						plugin.togglePlayState();
						//add a timeout so the hover state doesn't kick in.
						setTimeout(function () {
							$(this).removeClass('touched');
						}, 500);
					},
					touchstart: function (e) {
						e.stopPropagation();
						$(this).addClass('touched');
					}

				})
			);

			if (plugin.options.browserSupport.volumeControl) {
				plugin._volumeControl = plugin._createVolumeControl();
				plugin._playbackControls.append(plugin._volumeControl);
			}

			plugin._speedControl = plugin._createSpeedControl();
			plugin._playbackControls.append(plugin._speedControl);

			if (plugin.options.browserSupport.fullscreen) {
				plugin._playbackControls.append($('<span/>')
					.addClass(plugin._prefixClass('fullScreenButton'))
					.attr('title', 'Fullscreen Mode (F)')
					.on('click', function (e) {
						e.stopPropagation();
						plugin.toggleFullScreen();
						return false;
					})
				);
			}

			plugin._playbackControls.on('mouseleave', function (e) {
				if ($(e.relatedTarget).closest(plugin._progressBar).length === 0) {
					plugin.element.removeClass(plugin._prefixClass('progressbarFocused'));
					plugin._progressBar.off('mouseleave');
				}
			});

			return plugin._playbackControls;
		},

		//http://stackoverflow.com/questions/8335834/how-can-i-hide-the-android-keyboard-using-javascript
		_hideKeyboard: function () {
			//this set timeout needed for case when hideKeyborad
			//is called inside of 'onfocus' event handler
			setTimeout(function () {

				//create temp field

				var field = $('<input/>')
					.attr('type', 'text')
					.css({
						position: 'absolute',
						top: '-100px',
						opacity: 0,
						//-webkit-user-modify is nessesary for Android 4.x
						'-webkit-user-modify': 'read-write-plaintext-only',
						left: 0
					});
				$('body').append(field);

				field.on('focus', function () {
					//this timeout of 200ms is nessasary for Android 2.3.x
					setTimeout(function () {

						field.hide();
						setTimeout(function () {
							field.remove();
							$('body').focus();
						}, 14);

					}, 200);
				});

				field.focus();
			}, 50);
		},

		_showTimecodeOverlay: function (tcDiv, onchange) {
			var plugin = this;

			var tcField = $('<div/>')
				.addClass(plugin._prefixClass('tcSpinner'));

			function closeOverlay() {
				plugin._updateTimecodeTextField(
					tcDiv.data('fieldName'),
					tcField.timecodeField('value'),
					true /*force*/
				);
				overlay.remove();
				underlay.remove();
			}
			var underlay = $('<div/>').addClass('underlay')
				.on('click', function () {
					closeOverlay();
					return false;
				});

			var overlay = $('<div/>')
				.addClass(plugin._prefixClass('tcOverlay'))
				.append($('<h2/>').text(tcDiv.data('label')))
				.append(tcField)
				.append($('<a/>')
					.addClass('button')
					.text('ok')
					.on('click', function () {
						closeOverlay();
						return false;
					})
				);

			tcField.timecodeField({
				timecode: tcDiv.parent().data('value'),
				min: tcDiv.parent().data('min'),
				max: tcDiv.parent().data('max'),
				change: function () {

					plugin._updateTimecodeTextField(
						tcDiv.data('fieldName'),
						tcField.timecodeField('value'),
						true /*force*/
					);
					onchange.call(plugin, tcDiv.data('value'));
				}
			});

			plugin.element.append(underlay).append(overlay);

		},

		_createTimecodeTextField: function (fieldName, writable, onchange, label, pauseOnFocus) {
			var plugin = this;
			var div = $('<span/>')
				.addClass(plugin._prefixClass('tcTextField'))
				.addClass(plugin._prefixClass(fieldName))
				.data('label', label)
				.data('fieldName', fieldName);

			pauseOnFocus = pauseOnFocus === undefined ? false : pauseOnFocus;
			if (writable) {
				div.addClass(plugin._prefixClass('writable'));

			}

			var inputType = 'text';

			function selectAdjacentField(obj, which, changeContainer, forceChangeContainer) {
				var currentIndex = 0,
					allFields = null;
				if (forceChangeContainer === undefined) {
					forceChangeContainer = false;
				}
				switch (which) {
				case 'prev':
					if (!forceChangeContainer && obj.prevAll('.' + plugin._prefixClass('tcField')).length) {
						if (obj.prevAll('.' + plugin._prefixClass('tcField')).length) {
							obj.prevAll('.' + plugin._prefixClass('tcField')).eq(0).select().focus();
						}

					} else if (changeContainer) {
						obj.trigger('changeTimecode');
						currentIndex = 0;

						if (plugin.options.clipSelectionContainer.has(obj).length) {
							allFields = plugin.options.clipSelectionContainer.find('.' + plugin._prefixClass(
									'tcTextField') +
								'.' + plugin._prefixClass('writable'));
						} else {
							allFields = plugin.element.find('.' + plugin._prefixClass('tcTextField') +
								'.' + plugin._prefixClass('writable'));
						}

						allFields.each(function () {

							if ($(this).is(obj.closest('.' + plugin._prefixClass('tcTextField')))) {
								return false;
							}
							currentIndex++;
						});
						if (currentIndex === 0) {
							allFields.last().find('.' + plugin._prefixClass('tcField')).last().focus();
						} else {
							allFields.eq(currentIndex - 1).find('.' + plugin._prefixClass('tcField')).last().focus();
						}
						/*
						if (obj.closest('.' + plugin._prefixClass('pointField'))
								.prevAll('.' + plugin._prefixClass('pointField')).length) {
							obj.closest('.' + plugin._prefixClass('pointField'))
								.prevAll('.' + plugin._prefixClass('pointField')).eq(0)
								.find('.' + plugin._prefixClass('tcField')).last().focus();
						} else {
							plugin.element.find('.' + plugin._prefixClass('pointField')).last()
								.find('.' + plugin._prefixClass('tcField')).last().focus();
						}*/
					} else {
						//plugin._hideKeyboard();
					}
					break;
				case 'next':
					if (!forceChangeContainer && obj.nextAll('.' + plugin._prefixClass('tcField')).length) {
						//alert(obj.nextAll('.' + plugin._prefixClass('tcField')).eq(0).val());

						obj.nextAll('.' + plugin._prefixClass('tcField')).eq(0).focus();

					} else if (changeContainer) {
						obj.trigger('changeTimecode');
						currentIndex = 0;
						if (plugin.options.clipSelectionContainer.has(obj).length) {
							allFields = plugin.options.clipSelectionContainer.find('.' + plugin._prefixClass(
									'tcTextField') +
								'.' + plugin._prefixClass('writable'));
						} else {
							allFields = plugin.element.find('.' + plugin._prefixClass('tcTextField') +
								'.' + plugin._prefixClass('writable'));
						}

						allFields.each(function () {

							if ($(this).is(obj.closest('.' + plugin._prefixClass('tcTextField')))) {
								return false;
							}
							currentIndex++;
						});
						if (currentIndex == allFields.length - 1) {
							allFields.first().find('.' + plugin._prefixClass('tcField')).first().focus();
						} else {
							allFields.eq(currentIndex + 1).find('.' + plugin._prefixClass('tcField')).first().focus();
						}
						/*
						if (obj.closest('.' + plugin._prefixClass('pointField'))
							.nextAll('.' + plugin._prefixClass('pointField')).length) {
						obj.closest('.' + plugin._prefixClass('pointField'))
							.nextAll('.' + plugin._prefixClass('pointField'))
							.eq(0)
							.find('.' + plugin._prefixClass('tcField')).eq(0).focus();
						} else {
							plugin.element.find('.' + plugin._prefixClass('pointField')).first()
								.find('.' + plugin._prefixClass('tcField')).first().focus();
						}*/
					} else {
						//obj.trigger('change');
						obj.trigger('changeTimecode');
						obj.select();
						obj[0].setSelectionRange(0, 2);
						//plugin._hideKeyboard();
					}
					break;
				}

			}

			if (plugin.options.browserSupport.numberInput) {
				inputType = 'text';
			}
			div.append(
					$('<input/>')
					.attr('type', inputType)
					.data('min', '0')
					.data('max', '23')
					.attr('pattern', '[0-9]*')
					.attr('placeholder', 'HH')
					.addClass(this._prefixClass('tcField'))
					.addClass(this._prefixClass('hours'))
				).append(':')
				.append(
					$('<input/>').attr('type', inputType)
					.data('min', '0')
					.data('max', '59')
					.attr('pattern', '[0-9]*')
					.attr('placeholder', 'MM')
					.addClass(this._prefixClass('tcField'))
					.addClass(this._prefixClass('minutes'))
				)
				.append(':')
				.append(
					$('<input/>').attr('type', inputType)
					.data('min', '0')
					.data('max', '59')
					.attr('pattern', '[0-9]*')
					.attr('placeholder', 'SS')
					.addClass(this._prefixClass('tcField'))
					.addClass(this._prefixClass('seconds'))
				);
			div.data('min', '00:00:00').data('max', '23:59:59');

			let keyCount = 0;

			if (writable) {
				div.on({
					touchstart: function (e) {

						e.preventDefault();
						return false;
					},
					focus: function (e) {
						if (pauseOnFocus) {
							plugin.pause();
						}
						var currentDiv = $(this);
						if (currentDiv.hasClass(plugin._prefixClass('focused'))) {
							return;
						}
						keyCount = 0;
						$(this).select();
						this.setSelectionRange(0, 2);
						$('.' + plugin._prefixClass('focused')).removeClass(plugin._prefixClass('focused'));
						currentDiv.addClass(plugin._prefixClass('focused'));
						plugin._doc.on('mousedown.tcField', function (e) {
							if (!$.contains(div[0], e.target)) {
								currentDiv.removeClass(plugin._prefixClass('focused'));
								currentDiv.trigger('changeTimecode');
								plugin._doc.off('mousedown.tcField');
							}
						});
					},
					blur: function (e) {
						/*plugin._log(e);
						if (!$.contains(div[0], e.target)) {
							div.removeClass(plugin._prefixClass('focused'))
							$(this).trigger('changeTimecode');
						}*/
					},
					keydown: function (e) {
						e.stopPropagation();
						if (plugin.options.disableClipTrimming && div.closest('.pointField').length) {
							e.preventDefault();
							return false;
						}

						//pass through for numbers, number-pad numbers, left and right arrow keys, delete and backspace
						if (!e.shiftKey && (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode == 8 || e.keyCode ==
								46 ||
								e.keyCode >= 96 && e.keyCode <= 105 /*||  e.keyCode == 37 || e.keyCode == 39 */ )) {
							keyCount++;

							return;
						}
						switch (e.keyCode) {
						case 13: //enter
							$(this).val(pad(Number($(this).val()), 2));
							$(this).trigger('changeTimecode');
							if (div.hasClass(plugin._prefixClass('inPointPos'))) {
								selectAdjacentField($(this), 'next', true, false);
							} else {
								selectAdjacentField($(this), 'next', false);
							}
							break;

						case 38: //up arrow -- add 1
							e.preventDefault();
							$(this).val(pad(Number($(this).val()) + 1, 2));
							$(this).trigger('changeTimecode');
							$(this).select();
							$(this).focus();
							this.setSelectionRange(0, 2);
							return false;

						case 40: //down arrow -- subtract 1
							e.preventDefault();
							$(this).val(pad(Number($(this).val()) - 1, 2));
							$(this).trigger('changeTimecode');
							$(this).select();
							$(this).focus();
							this.setSelectionRange(0, 2);
							return false;
						case 9: //tab
							if (e.shiftKey) {
								selectAdjacentField($(this), 'prev', true);
							} else {
								selectAdjacentField($(this), 'next', true);
							}
							e.preventDefault();
							return false;
						case 37: //left
							e.preventDefault();
							selectAdjacentField($(this), 'prev', true);
							return false;
						case 39: //right
							e.preventDefault();
							selectAdjacentField($(this), 'next', true);
							return false;
						default:
							//prevent all other keypresses
							e.preventDefault();
							return false;
						}
					},
					keyup: function (e) {
						if (plugin.options.disableClipTrimming && div.closest('.pointField').length) {
							e.preventDefault();
							return false;
						}
						//move to the next part of the timecode when entering a number when the field is already full
						if ($(this).val().length > 2 || keyCount >= 2) {
							if (!e.shiftKey && (e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode == 8 || e.keyCode ==
									46 ||
									e.keyCode >= 96 && e.keyCode <= 105 /*||  e.keyCode == 37 || e.keyCode == 39 */ )) {
								e.preventDefault();
								$(this).val($(this).val().substring(0, 2));

								selectAdjacentField($(this), 'next', div.hasClass(plugin._prefixClass('inPointPos')));
								return false;
							}
						}
					},
					changeTimecode: function () {
						var fieldValue = Number($(this).val());
						var prev = null;
						var currentVal = $('.' + plugin._prefixClass('hours'), div).val() + ':' +
							$('.' + plugin._prefixClass('minutes'), div).val() + ':' +
							$('.' + plugin._prefixClass('seconds'), div).val();
						if (currentVal == div.data('value')) {
							return;
						}

						//if the fied is empty make it 0
						if (!fieldValue) {
							fieldValue = 0;
							$(this).val('00');
						}

						if (fieldValue > Number($(this).data('max'))) {
							prev = $(this).prevAll('.' + plugin._prefixClass('tcField')).first();
							if (prev.length) {
								prev.val(pad(Number(prev.val()) + 1, 2));
								$(this).val(pad(Number($(this).data('min')), 2));
								prev.trigger('changeTimecode');
								return;
							} else {
								//set the field to its' maximum value
								plugin._updateTimecodeTextField(fieldName, div.data('max'));
							}
						} else if (fieldValue < Number($(this).data('min'))) {
							prev = $(this).prevAll('.' + plugin._prefixClass('tcField')).first();
							if (prev.length) {
								prev.val(pad(Number(prev.val()) - 1, 2));
								$(this).val(pad(Number($(this).data('max')), 2));
								prev.trigger('changeTimecode');
								return;
							} else {
								//set the timecodeField to its minumum value
								plugin._updateTimecodeTextField(fieldName, div.data('min'));
							}

						}
						if ($(this).hasClass(plugin._prefixClass('focused'))) {
							$(this).select();
							$(this).focus();
							this.setSelectionRange(0, 2);
						}

						div.data('value', $('.' + plugin._prefixClass('hours'), div).val() + ':' +
							$('.' + plugin._prefixClass('minutes'), div).val() + ':' +
							$('.' + plugin._prefixClass('seconds'), div).val());

						onchange.call(plugin, div.data('value'));

					},
					'mouseup': function (e) {
						e.preventDefault();
					}
				}, '.tcField');

				if (plugin.options.browserSupport.touch) {
					div.append($('<span/>').addClass('touchShield'))
						.on('showTimecodeOverlay', function() {
							plugin._showTimecodeOverlay(div, onchange);
						});
				}
	
				if (false && plugin.options.browserSupport.touch) {
					div.append($('<span/>').addClass('touchShield')
						.on({
							'touchstart': function (e) {
								$(this).siblings('input').prop('readonly', true);
								$(this).data('touched', true);
								if (plugin.element.hasClass(plugin._prefixClass('disableClipTrimming'))) {
									$(this).data('touched', false);
									$(this).siblings('input').prop('disabled', false);
									return;
								}
								if ($(this).data('touched')) {
									e.preventDefault();
									e.stopPropagation();
									plugin._showTimecodeOverlay(div, onchange);
									//$(this).data('touched', false);
									$(this).siblings('input').prop('disabled', false);
									return false;
								} else {

									$(this).data('touched', false);
									var xPos = e.pageX;
									div.find('.' + plugin._prefixClass('tcField')).each(function () {
										var el = $(this);
										if (el.offset().left <= xPos && el.offset().left + el.width() >= xPos) {
											el.trigger('focus');
											return false;
										}
									});
								}
								return false;

							},
							'touchmove': function() {

							},
							// 'click': function (e) {
							// 	if ($(this).data('touched')) {
							// 		e.preventDefault();
							// 		e.stopPropagation();
							// 		$(this).data('touched', false);
							// 		return false;
							// 	}
							// },

							'click': function (e) {

							}

						})
					);
				}
			} else {
				$('.' + this._prefixClass('tcField'), div).prop('disabled', true);
			}
			return div;
		},

		_updateTimecodeTextField: function (fieldName, value, force) {

			var plugin = this;
			var parts = value.split(':');
			var elements = $('.' + plugin._prefixClass(fieldName), plugin.element);
			if (plugin.options.clipSelectionContainer) {
				elements = elements.add($('.' + plugin._prefixClass(fieldName), plugin.options.clipSelectionContainer));
			}
			elements.each(function () {
				var container = $(this);
				if (force === undefined) {
					force = false;
				}
				if (!force && container.find('.' + plugin._prefixClass('focused')).length) {
					return false;
				}

				container.data('value', value);
				for (var i = 0; i < parts.length; i++) {
					$('.' + plugin._prefixClass('tcField'), container).eq(i).val(parts[i]);
				}
			});
		},

		_updateTimecodeTextFieldMinMax: function (fieldName, minValue, maxValue) {
			var container = $('.' + this._prefixClass(fieldName), this.element);
			container.data('min', minValue).data('max', maxValue);

		},

		_setupHtml5VideoEvents: function () {
			var plugin = this;

			plugin._videoPlayer.obj.on({
				pause: function (event, params) {
					if (!plugin._seeking && (!params || params.updatePlayState === true)) {
						plugin._togglePlayStateDisplay(false);
					}

					$('.' + plugin._prefixClass('statusText')).text('pause');

					if (plugin.options.thumbnailPreview) {
						if (plugin.options.debug) {
							plugin._log('_showThumbnailPreview: ' + this.currentTime);
						}

						if (plugin.options.showThumbnailOnPause && (params && params.userAction === true)) {
							plugin._showThumbnailPreview(this.currentTime);
						}
					}
					plugin._trigger("pause", event, {});
				},
				play: function (event) {
					//plugin._log('play ' + this.seeking );
					console.log('play');
					if (plugin._unloaded) {
						return false;
					}
					if (!plugin._seeking) {
						plugin._togglePlayStateDisplay(true);
					}
					plugin._trigger("play", event, {});
					$('.' + plugin._prefixClass('statusText')).text('play');
				},
				playing: function () {
					//plugin._log('playing ' + this.seeking );
					if (plugin._html5LoadFinishedDfd) {
						//$('.statusText2').append("<br/>Resolved deferred object on 'playing' event.");
						plugin._html5LoadFinishedDfd.resolve();
						return;
					}

					if (plugin._initialSeek) {
						//$('.statusText2').append("<br/>seek after 'playing' event.");
						plugin.seek(plugin._seekPos);
						return;
					}
					//never show a loading state if the video is playing.
					if (!plugin._seeking) {
						if (this.seeking) {
							$(this).one('seeked', function () {
								//plugin._log('stop waiting after seek');
								//$('.statusText2').append('<br/>stop waiting after seek.');
								plugin._toggleLoadingStateDisplay(false);
								plugin._togglePlayStateDisplay(true);
								plugin._hideThumbnailPreview();
								this.play();
							});
						} else {
							//plugin._log('stop waiting on playing');
							//$('.statusText2').append("<br/>stop waiting on 'playing' event.");
							plugin._toggleLoadingStateDisplay(false);
							plugin._togglePlayStateDisplay(true);
							plugin._hideThumbnailPreview();
						}

					}
					$('.' + plugin._prefixClass('statusText')).text('playing');

				},
				canplay: function (event) {
					if (plugin._html5LoadFinishedDfd) {
						//$('.statusText2').append("<br/>Resolved deferred object on 'canplay' event.");

						plugin._html5LoadFinishedDfd.resolve();
						return;
					}
					//plugin._log('canPlay');
					plugin._canPlay = true;
					var player = this;
					//plugin._toggleLoadingStateDisplay(false);
					plugin._trigger("canplay", event, {});
					$('.' + plugin._prefixClass('statusText')).text('canplay');
				},
				waiting: function (event) {
					plugin._toggleLoadingStateDisplay(true);
					plugin._trigger("waiting", event, {});
					$('.' + plugin._prefixClass('statusText')).text('waiting');
				},
				stalled: function (event) {
					plugin._trigger("stalled", event, {});
					$('.' + plugin._prefixClass('statusText')).text('stalled');
				},
				loadedmetadata: function (event) {
					if (plugin._html5LoadFinishedDfd) {
						//$('.statusText2').append("<br/>Resolved deferred object on 'loadedmetadata' event.");
						plugin._html5LoadFinishedDfd.resolve();

					}
					plugin._initializeControls();
					plugin._trigger("load", event, {});
					$('.' + plugin._prefixClass('statusText')).text('loaded meta data');
					plugin._updateBufferedDisplay(this.buffered);
					plugin._videoIsLoaded = true;
				},
				loadeddata: function (event) {

					$('.' + plugin._prefixClass('statusText')).text('stalled' + this.readyState);
					plugin._updateBufferedDisplay(this.buffered);
				},
				durationchange: function () {
					if (plugin._html5LoadFinishedDfd) {

						//$('.statusText2').append("<br/>Resolved deferred object on 'durationchange' event.");
						plugin._html5LoadFinishedDfd.resolve();
					}
					//if (plugin.options.inPoint) {
					//	plugin.seek(plugin.options.inPoint);
					//}
					//plugin._videoPlayer.obj.currentTime = plugin.options.inPoint;
					//if (plugin._initialLoad && plugin._videoPlayer.obj[0].duration ) {
					//	performInitialSeek();
					//}
					$('.' + plugin._prefixClass('statusText')).text('duration change');
				},
				progress: function (event) {
					plugin._updateBufferedDisplay(this.buffered);
				},
				timeupdate: function (event) {
					//don't update the playhead position if the video is not
					//fully loaded. This avoids the back and forth jump when
					//starting playback after a seek.
					if (this.paused || !this.currentTime || this.currentTime == plugin._currentPos || this.readyState !=
						4 || plugin._initialSeek ||
						plugin._seeking || plugin._draggingScrubber || this.seeking) {
						return;
					}
					plugin._updatePlayheadPosition(this.currentTime);

				},
				volumechange: function (event) {
					if (this.volume && plugin.options.disableAudio) {
						this.volume = 0;
					} else {
						plugin._updateVolumeDisplay(this.volume);
					}
				},
				seeking: function (event) {

					plugin._toggleLoadingStateDisplay(true);
					$('.' + plugin._prefixClass('statusText')).text('seeking');
				},
				seeked: function (event) {

					if (plugin._initialSeek) {
						//plugin._log('seeked after initial seek');
						if (plugin._autoPlay) {
							plugin._autoPlay = false;
						}
						plugin.play();
						plugin._initialSeek = false;
					}
					var offset = this.currentTime;
					$('.' + plugin._prefixClass('statusText')).text('seeked');
				},
			});
		},

		_initializeControls: function () {
			var plugin = this;
			if (!plugin._videoDuration) {
				plugin._videoDuration = Math.max(0, plugin.options.duration);
				if (plugin._videoDuration <= plugin.options.maxZoom) {
					plugin.element.addClass('disableZoom');
					plugin._zoomControl.addClass('disabled');

				} else {
					plugin.element.removeClass('disableZoom');
					plugin._zoomControl.removeClass('disabled');
				}

			}
			if (plugin._showingVideo && !plugin._progressBarDuration) {
				plugin._updateInnerBar(0, plugin._videoDuration);
			}
			plugin._startTc = plugin.options.getTimecode(plugin.options.startOffset, 0, plugin.options.fps,
				true);
			plugin._endTc = plugin.options.getTimecode(plugin.options.startOffset, plugin._videoDuration,
				plugin.options
				.fps, true);
			plugin._updateTimecodeTextField('duration', plugin._endTc);
			if (plugin._currentPos === 0) {
				plugin._updateTimecodeTextField('currentPos', plugin._startTc);
			}

			plugin._updateTimecodeTextFieldMinMax('currentPos', plugin._startTc, plugin._endTc);

			//if (!this.options.inPoint) {
			//	this.setIn(0, false /*suppress callback */, true /*force redraw */);
			//}
			//if (!this.options.outPoint) {
			//	this.setOut(this._videoDuration, false /*suppress callback */, true /*force redraw */);
			//}
		},

		_toggleLargePlayButton: function (show) {
			if (show) {
				if (this._loadingState == 'loading') {
					this._showLargePlayButtonAfterLoad = true;
					this.element.find('.' + this._prefixClass('largePlayButton')).hide();
					return;
				}
				this.element.find('.' + this._prefixClass('largePlayButton')).show();
			} else {
				this.element.find('.' + this._prefixClass('largePlayButton')).hide();
			}
		},

		_togglePlayStateDisplay: function (isPlaying) {
			let plugin = this;
			if (isPlaying === undefined) {
				isPlaying = plugin.isPlaying();
			}
			plugin.element.toggleClass('playing', isPlaying);
			plugin.element.find('.' + plugin._prefixClass('playButton'), this.element)
				.toggleClass('playing', isPlaying);
			if (isPlaying) {
				plugin._toggleLargePlayButton(false);
			} else if (this.options.showLargePlayBuutonOnPause) {
				plugin._toggleLargePlayButton(true);
			}
		},

		_toggleLoadingStateDisplay: function (isLoading) {

			if (isLoading) {
				if (this.element.find('.' + this._prefixClass('largePlayButton')).is(':visible')) {
					this._showLargePlayButtonAfterLoad = true;
					this._toggleLargePlayButton(false);
				}

				this._loadingState = 'loading';
				this._trigger('startLoading', null, {});
			} else {
				if (this._showLargePlayButtonAfterLoad) {
					this._showLargePlayButtonAfterLoad = false;
					this._toggleLargePlayButton(true);
				}
				this._loadingState = 'loaded';
				this._trigger('stopLoading', null, {});
			}
		},

		_updateVolumeDisplay: function (volume) {
			var plugin = this;

			$('.' + plugin._prefixClass('volumeLevel'), plugin._volumeControl).height(volume *
				$('.' + plugin._prefixClass('volumeLevelBG'), plugin._volumeControl).height());
			plugin._volumeControl.removeClass('low mid high');
			if (volume < 1 / 3) {
				plugin._volumeControl.addClass('low');
			} else if (volume < 2 / 3) {
				plugin._volumeControl.addClass('mid');
			} else {
				plugin._volumeControl.addClass('high');
			}
		},

		_isBuffered: function (pos) {
			var buffered = this._buffered,
				start, end;

			if (buffered) {
				for (var i = 0; i < buffered.length; i++) {
					if (typeof (buffered[i]) != 'undefined') {
						start = buffered[i].start;
						end = buffered[i].end;
					} else {
						start = buffered.start(i);
						end = buffered.end(i);
					}
					if (pos >= start && pos <= end) {
						return true;
					}
				}
				return false;
			}
			return false;
		},

		_updateBufferedDisplay: function (buffered) {
			var plugin = this, i, start, end, bufferEl = null,
				newBuffer = null;
			if (buffered) {
				this._buffered = buffered;
				plugin._log('Buffer Updated.');
				$('.bufferStatus').empty();
				if (this.options.useCanvasForBufferedDisplay) {
					var canvas = $('.' + this._prefixClass('buffered'), this.element)[0];
					var ctx = canvas.getContext('2d');
					ctx.fillStyle = "white";
					ctx.fillRect(0, 0, canvas.width, canvas.height);
					ctx.fillStyle = "#0000FF";
					for (i = 0; i < buffered.length; i++) {
						
						plugin._log('Start: ' + buffered.start(i) + ' End: ' + buffered.end(i) + ' Duration: ' +
							this._videoDuration);
						
						if (buffered[i].start && buffered[i].end) {
							start = buffered[i].start / this._videoDuration * canvas.width;
							end = buffered[i].end / this._videoDuration * canvas.width;
						} else {
							start = buffered.start(i) / this._videoDuration * canvas.width;
							end = buffered.end(i) / this._videoDuration * canvas.width;
						}
						ctx.fillRect(start, 0, Math.floor(end - start), canvas.height);

					}
				} else {
					bufferEl = $('.' + this._prefixClass('buffered'), this.element);
					newBuffer = $('<div/>').addClass(this._prefixClass('buffered'));

					for (i = 0; i < buffered.length; i++) {
						if (typeof (buffered[i]) != 'undefined') {
							start = buffered[i].start;
							end = buffered[i].end;
						} else {
							start = buffered.start(i);
							end = buffered.end(i);
						}

						plugin._log('Start: ' + start + ' End: ' + end + ' Duration: ' + this._videoDuration);
						
						$('.bufferStatus').append('Start: ' + start + ' End: ' + end + ' Duration: ' + this._videoDuration +
							'<br/>');

						newBuffer.append(
							$('<div/>')
							.addClass(this._prefixClass('bufferedSection'))
							.css({
								left: 100 * start / this._videoDuration + '%',
								width: 100 * ((end - start) / this._videoDuration) + '%'
							})
						);

					}
					bufferEl.replaceWith(newBuffer);
				}
			}
		},

		_updateInClipDisplay: function (offset) {
			var plugin = this;
			if (!plugin.element.hasClass(plugin._prefixClass('fullClip')) &&
				offset >= plugin.options.inPoint && offset <= plugin.options.outPoint) {
				plugin.element.addClass(plugin._prefixClass('inClip'));
			} else {
				if (plugin.element.hasClass(plugin._prefixClass('inClip'))) {
					plugin.element.removeClass(plugin._prefixClass('inClip'));
					if (offset > plugin.options.outPoint) {
						plugin.pause();
					}
				}
			}
		},

		_updateLogDisplay: function (logEntry) {
			var plugin = this;
			var logEl = plugin.element.find('.' + plugin._prefixClass('logDisplay'));
			logEl.html(logEntry);
			if (logEl[0].scrollHeight > logEl.height()) {
				logEl.addClass(plugin._prefixClass('overflowing'));
			} else {
				logEl.removeClass(plugin._prefixClass('overflowing'));
			}
		},

		_updatePlayheadPosition: function (offset, ignoreFrames, alignment) {
			var plugin = this,
				dfd = new $.Deferred(),
				timecode = '',
				playheadOffset = 0;
			alignment = alignment === undefined ? 'center' : alignment;
			if (plugin._initialSeek) {
				return;
			}
			if (ignoreFrames === undefined) {
				ignoreFrames = false;
			}

			//this._videoDuration = this._videoPlayer.obj[0].duration;

			timecode = plugin.options.getTimecode(plugin.options.startOffset, offset, plugin.options
				.fps, ignoreFrames);
			plugin._textProgress.data('value', timecode);

			plugin._updateTimecodeTextField('currentPos', timecode);
			plugin._currentPos = offset;

			//if (!plugin._draggingScrubber) {
			plugin._trigger("timeupdate", null, {
				offset: offset,
				timecode: timecode
			});
			//}
			plugin._updateInClipDisplay(offset);
			if (plugin.options.displayLog) {
				plugin._updateLogDisplay(plugin.options.getCurrentLogEntry(offset));
			}
			if (plugin.options.thumbnailPreview && plugin._showingThumbnails) {
				plugin._showThumbnailPreview(offset);
			}
			if (offset >= plugin._progressBarStartPos &&
				offset <= plugin._progressBarStartPos + plugin._progressBarDuration) {
				playheadOffset = 100 * (offset - plugin._progressBarStartPos) / plugin._progressBarDuration;
				plugin._playhead.css('left', playheadOffset + '%').show();
				dfd.resolve();
			} else {
				switch (alignment) {
				case 'right':
					$.when(plugin._updateInnerBar(
						Math.max(0, offset - plugin._progressBarDuration),
						plugin._progressBarDuration, true)).done(function () {
						dfd.resolve();
					});
					break;
				case 'center':
					$.when(plugin._updateInnerBar(
						Math.max(0, offset - plugin._progressBarDuration / 2),
						plugin._progressBarDuration, true)).done(function () {
						dfd.resolve();
					});
					break;
				case 'left':
					plugin._log('auto move innerbar', offset, plugin._progressBarStartPos, plugin._progressBarDuration);
					$.when(plugin._updateInnerBar(
						offset,
						plugin._progressBarDuration, true)).done(function () {
						dfd.resolve();
					});
					break;
				case 'hide':
					plugin._playhead.hide();
				}
			}
			return dfd.promise();
		},

		_triggerPlayerEvent: function (eventName, params) {
			var plugin = this;
			if (plugin._videoPlayer.type == 'html5') {
				plugin._videoPlayer.obj.trigger(eventName, params);
			} else {
				//send flasch call
				plugin._videoPlayer.obj.flash(function () {
					switch (eventName) {
					case 'play':
						if (this.playVideo) {
							this.playVideo(plugin._currentPos);
						}
						break;
					case 'pause':
						if (this.stopVideo) {
							this.stopVideo();
						}
						break;
					case 'setIn':
						if (this.setIn) {
							this.setIn(params.offset);
						}
						break;
					case 'setOut':
						if (this.setOut) {
							this.setOut(params.offset);
						}
						break;
					case 'load':
						this.load(params);
						plugin._initializeControls();
						break;
					case 'unload':
						//this.unload();
						break;
					case 'setVolume':
						this.setVolume(params.level);
						break;
					case 'status':
						if (typeof (this.getStatus) !== 'undefined') {
							this.getStatus();
						}
						break;
					}

				});

			}
		},

		_showThumbnailPreview: function (pos, updatePlayheadPos) {
			var plugin = this;

			if (!plugin.options.thumbnailPreview) {
				return;
			}
			
			plugin._showingThumbnails = true;
			pos = pos === undefined ? 0 : pos;
			updatePlayheadPos = updatePlayheadPos === undefined ? true : updatePlayheadPos;

			if (updatePlayheadPos) {
				plugin._currentThumbnailPos = pos;
				plugin._currentPos = pos;
			}
			var thumbnailContainer = $('.' + plugin._prefixClass('thumbnailPreview'), plugin.element);
			thumbnailContainer.show();
			//pos = Math.max(1, Math.floor(pos));
			plugin.options.updateThumbnail(thumbnailContainer, pos);
			plugin._videoPlayer.obj.addClass(plugin._prefixClass('hidden'));
			if (!plugin._initialLoad) {

				plugin._toggleLoadingStateDisplay(false);
			}

		},

		_hideThumbnailPreview: function () {
			var plugin = this;
			var thumbnailContainer = $('.' + plugin._prefixClass('thumbnailPreview'), plugin.element);
			thumbnailContainer.hide();
			plugin._videoPlayer.obj.removeClass(plugin._prefixClass('hidden'));

			plugin._showingThumbnails = false;
		},

		_clearThumbnailPreview: function () {
			var plugin = this;
			if (!plugin.options.thumbnailPreview) {
				return;
			}

			var thumbnailContainer = $('.' + plugin._prefixClass('thumbnailPreview'), plugin.element);
			thumbnailContainer.css({
				backgroundImage: '',
				backgroundPosition: ''
			});
		},

		_load: function (videoInfo, force, inPos) {

			if (force === undefined) {
				force = false;
			}
			if (inPos === undefined) {
				inPos = 0;
			}

			var dfd = new $.Deferred();
			var plugin = this;

			if (plugin.videoIsLoaded()) {
				if (plugin.options.file == videoInfo.file) {
					console.log(plugin.options.file + ' already loaded');
					$.each(videoInfo, function (index, value) {
						plugin.options[index] = value;
					});
					this._toggleLargePlayButton(true);
					//$('.statusText2').append('<br/>resolved - videoIsLoaded.');
					dfd.resolve();
					return;
				}
				plugin.unload();
			}
			
			plugin._playbackStarted = false;
			plugin._initialLoad = true;
			
			if (!plugin.videoIsLoaded()) {
				$.each(videoInfo, function (index, value) {
					plugin.options[index] = value;
				});

				plugin._videoDuration = Math.max(0, videoInfo.duration);
				if (plugin._videoDuration <= plugin.options.maxZoom) {
					plugin.element.addClass('disableZoom');
					plugin._zoomControl.addClass('disabled');
				} else {
					plugin.element.removeClass('disableZoom');
					plugin._zoomControl.removeClass('disabled');
				}

				//initialize controls before the video is loaded
				//since the ipad will not load the metadata before playing the video
				//the duration will be corrected if necessary when we can get it from the
				//video.
				//don't call this until the video has been initialized if we're using
				//flash because the events will not work.
				if (this.options.useVideoElements()) {

					plugin._initializeControls();
				}
			}
			if (!videoInfo.showVideo) {
				dfd.resolve();
			} else if (!force && this.options.thumbnailPreview && plugin._videoPlayer.type != 'flash') {

				plugin._videoIsLoaded = false;
				plugin._showThumbnailPreview(plugin._currentPos);
				plugin._toggleLargePlayButton(true);

				//$('.statusText2').append('<br/>resolved - thumbnail preview.');
				dfd.resolve();

			} else {

				switch (plugin._videoPlayer.type) {
				case 'html5':
					plugin._videoPlayer.obj.empty().append(
						$('<source/>')
						.attr('type', plugin.options.mimeType)
						.attr('src', plugin.options.videoBasePath + plugin.options.file /* + '#t=' + hashIn */ )
					);

					if (inPos) {
						plugin._videoInPos = inPos;
						plugin._autoPlay = true;
					}
					plugin._videoIsLoaded = false;

					plugin._toggleLoadingStateDisplay(true);
					plugin._html5LoadFinishedDfd = new $.Deferred();

					//plugin._videoPlayer.el.load();

					$.when(plugin._html5LoadFinishedDfd).done(function () {
						plugin._html5LoadFinishedDfd = null;
						//plugin._videoPlayer.obj.play();
						plugin._videoIsLoaded = true;
						//$('.statusText2').append('<br/>resolved - _html5LoadFinishedDfd.');
						dfd.resolve();
					});
					break;
				case 'flash':
					var flashParams = {
						url: plugin.options.videoBasePath + plugin.options.file,
						timecodeOffset: plugin.options.startOffset,
						inTime: plugin.options.inPoint ? plugin.options.inPoint : 0,
						outTime: plugin.options.outPoint ? plugin.options.outPoint : plugin.options.duration,
						play: plugin.options.autoPlay,
						nonDropFrame: plugin.options.fps == 30,
						receiveAudio: !plugin.options.disableAudio,
						clipTrimming: !plugin.options.disableClipTrimming,
						aspectRatio: plugin.options.aspectRatio
					};
					plugin._toggleLargePlayButton(false);
					plugin._videoInPos = inPos;

					plugin._videoPlayer.obj.flash(function () {
						//Wait for the flash object to be initialized before
						//calling the load function.
						if (this.load !== undefined) {
							plugin._flashLoadFinishedDfd = new $.Deferred();
							$.when(plugin._flashLoadFinishedDfd).done(function () {

								plugin._flashLoadFinishedDfd = null;
								plugin._videoIsLoaded = true;
								plugin._toggleLargePlayButton(true);

								if (inPos) {
									plugin.seek(plugin._videoInPos);
								}

								dfd.resolve();
							});
							plugin._triggerPlayerEvent('load', flashParams);

						} else {
							//if the flash player is not yet initialized
							//call the _load method again.
							setTimeout(function () {
								$.when(plugin._load.call(plugin, videoInfo, force, inPos)).done(function () {

									dfd.resolve();

								});
							}, 100);
						}
					});
					break;
				}
			}
			return dfd.promise();
		},

		load: function (videoInfo) {
			var plugin = this;
			var dfd = new $.Deferred();
			this._unloaded = false;
			plugin.toggleFineTuning(videoInfo.showFineTuningBar);
			plugin._showingVideo = videoInfo.showVideo;
			
			$.when(plugin._load(videoInfo)).done(function () {
				plugin.resetZoom();
				if (plugin.options.keyboardHandling) {
					plugin._bindKeys();
				}
				plugin.setIn(videoInfo.inPoint, true /*suppress callback */ , true /*force draw */ );
				if (videoInfo.outPoint) {
					plugin.setOut(videoInfo.outPoint, true /*suppress callback */ , true /*force draw */ );
				}

				var timecodeIn = plugin.options.getTimecode(plugin.options.startOffset, 0, plugin.options
					.fps, true);
				var timecodeOut = plugin.options.getTimecode(plugin.options.startOffset, plugin._videoDuration,
					plugin.options.fps, true);
				
				plugin._updateTimecodeTextFieldMinMax('textProgress', timecodeIn, timecodeOut);
				plugin.toggleClipTrimming(plugin.options.disableClipTrimming);
				plugin.toggleClipControls(plugin.options.showClipControls);

				if (plugin._showingVideo) {
					plugin.toggleFineTuning(plugin.options.showFineTuningBar);
					if (plugin.options.disableAudio) {
						plugin.mute(true);
						plugin.element.addClass(plugin._prefixClass('audioDisabled'));
					} else {
						plugin.mute(false);
						plugin.element.removeClass(plugin._prefixClass('audioDisabled'));
						plugin.setVolume(plugin.options.volume);
					}

					plugin._updatePlayheadPosition(videoInfo.inPoint);
					plugin.seek(Number(videoInfo.inPoint), videoInfo.autoPlay);
				}
				plugin._resizeObserver.observe(plugin.element[0]);
				// if (plugin._currentZoom != 0)
				// 	plugin.setZoom(0);
				
				dfd.resolve();
			});
			return dfd.promise();
		},

		unload: function () {
			var plugin = this;
			plugin.options.file = '';
			if (plugin.videoIsLoaded()) {

				switch (plugin._videoPlayer.type) {
				case 'html5':

					plugin.pause();
					plugin._videoPlayer.obj.empty();
					var newPlayer = $('<video playsinline>')
						//.attr('preload', 'metadata')
						.addClass(plugin._prefixClass('playerElement'));
					plugin._videoPlayer.obj.replaceWith(newPlayer);
					plugin._videoPlayer.obj = newPlayer;
					plugin._videoPlayer.el = newPlayer[0];
					plugin._videoPlayer.el.load();
					plugin._setupHtml5VideoEvents();
					break;
				case 'flash':
					plugin._triggerPlayerEvent('unload');
					break;
				}
			}
			plugin.element.removeClass('playing');
			plugin._unloaded = true;
			plugin._videoIsLoaded = false;
			plugin._startTc = '00:00:00';
			plugin._endTc = '23:59:59';
			plugin._currentPos = 0;
			plugin._videoDuration = 0;
			plugin._zoom = 0;
			$('.' + plugin._prefixClass('buffered'), plugin.element).empty();

			//plugin.setZoom(0);
			//$('.statusText2').append('<br/>stop waiting on unload.');
			plugin._toggleLoadingStateDisplay(false);
			plugin._clearThumbnailPreview();
			plugin._doc.off('.videoPlayerKeys');
			plugin._resizeObserver.disconnect();

		},

		reloadVideo: function (pos) {

			var plugin = this;

			if (!plugin.videoIsLoaded || (plugin._reloadingDfd && plugin._reloadingDfd.state() ==
					'pending')) {
				return;
			}
			plugin._reloadingDfd = new $.Deferred();

			//plugin._toggleLoadingStateDisplay(false);
			$.when(plugin.getCurrentTime()).done(function (time) {
				time = !time ? pos : time;

				plugin._videoIsLoaded = false;
				plugin.pause();

				if (plugin.options.useVideoElements()) {

					plugin._videoPlayer.obj.remove();
					plugin._createHTMLVideoPlayer(plugin.element.find('.' + plugin._prefixClass('playerDiv')));
					plugin._showThumbnailPreview(time);
					plugin._updatePlayheadPosition(time);
					plugin._reloadingDfd.resolve();

				} else {
					var player = plugin.element.find('.' + (plugin._prefixClass('playerDiv')));
					$('.flashContainer', player).remove();
					var flashObj = plugin.options.flashObj();
					var flashContainer = $('<div/>').addClass('flashContainer');
					player.prepend(flashContainer);
					flashContainer.flash({
						swf: flashObj.swf,
						width: '100%', //flashObj.width,
						height: '100%', //flashObj.height,
						// these arguments will be passed into the flash document
						flashvars: flashObj.flashVars,
						wmode: 'opaque',
						allowFullScreen: true
					});

					plugin._videoPlayer = {
						type: 'flash',
						obj: flashContainer,
						properties: {
							isPlaying: false,
							muted: false
						}
					};
					plugin._updatePlayheadPosition(time);
					$.when(plugin._load(plugin.options, true, time)).done(function () {
						plugin._reloadingDfd.resolve();
					});
				}
				return;
			});
		},

		hasVideo: function () {
			return this.options.file !== '';
		},

		videoIsLoaded: function () {
			return this._videoIsLoaded;
		},

		getTimecodeOffset: function () {
			return this.options.startOffset;
		},

		toggleClipTrimming: function (value) {
			var plugin = this;
			plugin.options.disableClipTrimming = value;
			if (value) {
				plugin.element.addClass(plugin._prefixClass('disableClipTrimming'));
			} else {
				plugin.element.removeClass(plugin._prefixClass('disableClipTrimming'));
			}
		},

		toggleClipControls: function (value) {
			var plugin = this;
			plugin.options.showClipControls = value;
			if (value) {
				plugin.element.removeClass(plugin._prefixClass('hideClipControls'));
			} else {
				plugin.element.addClass(plugin._prefixClass('hideClipControls'));
			}
		},

		toggleFineTuning: function (value) {
			var plugin = this;
			plugin.options.showFineTuningBar = value;
			if (value) {
				plugin.element.removeClass(plugin._prefixClass('hideFineTuning'));
			} else {
				plugin.element.addClass(plugin._prefixClass('hideFineTuning'));
			}
		},

		setEndPoint: function (which, timeVal, suppressCallback, forceRedraw) {
			var dfd = $.Deferred(),
				plugin = this;

			suppressCallback = (suppressCallback === undefined) ? false : suppressCallback;
			forceRedraw = (forceRedraw === undefined) ? false : forceRedraw;
			if (!forceRedraw && plugin.options.disableClipTrimming) {
				return;
			}

			function helper(value) {
				//timecode
				var prevVal = which == 'in' ? plugin.options.inPoint : plugin.options.outPoint;
				if (value != Number(value)) {
					value = plugin.options.getOffset(plugin.options.startOffset, value, plugin.options.fps);
				}
				if (value < 0) {
					value = 0;
				}
				if (value > plugin._videoDuration) {
					value = plugin._videoDuration;
				}

				if (value != prevVal || forceRedraw) {

					if (which == 'in') {
						if (!plugin.options.outPoint || plugin.options.outPoint == -1) {
							plugin.setOut(plugin._videoDuration);
						}
						if (plugin.options.outPoint && value > plugin.options.outPoint - plugin.options.minClipLength) {
							value = plugin.options.outPoint - plugin.options.minClipLength;
						}

						plugin.options.inPoint = value;
					} else {
						if (plugin.options.inPoint && value < plugin.options.inPoint + plugin.options.minClipLength) {
							value = plugin.options.inPoint + plugin.options.minClipLength;
						}

						plugin.options.outPoint = value;
					}
					plugin._updateClipDisplay();
					//plugin.seek(value, false, false);

					if (!suppressCallback) {
						plugin._trigger(which == 'in' ? 'setIn' : 'setOut', null, {
							value: value
						});
					}
				}
				return value;
			}

			if (timeVal === undefined) {
				$.when(this.getCurrentTime()).done(function (data) {
					dfd.resolve(helper(data));
				});

			} else {
				dfd.resolve(helper(timeVal));
			}
			return dfd.promise();
		},

		setIn: function (inTime, suppressCallback, forceRedraw) {
			this._prevClip.inPoint = this.options.inPoint;
			return this.setEndPoint('in', inTime, suppressCallback, forceRedraw);
		},

		setOut: function (outTime, suppressCallback, forceRedraw) {
			this._prevClip.outPoint = this.options.outPoint;
			return this.setEndPoint('out', outTime, suppressCallback, forceRedraw);
		},

		_ease: function (x) {
			//return x*x; //quad
			return x === 0 ? 0 : Math.pow(2, 10 * x - 10); //exponential
		},

		_easeInvert: function (y) {
			return y === 0 ? y : (Math.log(y) / Math.log(2) + 10) / 10;
		},

		resetZoom: function() {
			let plugin = this;
			plugin._currentZoom = 0;
			plugin._progressBarStartPos = 0;
			plugin._progressBarDuration = plugin._videoDuration;
			plugin._zoomControl.find(plugin._prefixClass('.pointer'))
				.css('left', 0);
			plugin._zoomControl.find(plugin._prefixClass('.barFill'))
				.css('width','0px');
			plugin._progressBar.find('.innerBar').css({
				width: '100%',
				left: '0%'
			});
			$.each(plugin.options.progressBarBg, function (index, bg) {
				if (100 >= bg.zoom.min && 100 < bg.zoom.max) {
					plugin._progressBar.find('.bg.' + bg.className).addClass('visible');
				} else {
					plugin._progressBar.find('.bg.' + bg.className).removeClass('visible');
				}
			});
			plugin.element.find('.jumpToClipIn').removeClass('offscreen right left');
			plugin.element.find('.jumpToClipOut').removeClass('offscreen right left');
		},

		setZoom: function (zoom, startPos, playheadAlignment) {
			var plugin = this,
				progressbarDuration = plugin._videoDuration,
				currentPosRatio = plugin._progressBarDuration ?
				(plugin._currentPos - plugin._progressBarStartPos) / plugin._progressBarDuration : 0;
			zoom = Math.max(0, Math.min(1, zoom));
			plugin._currentZoom = zoom;
			plugin._log('Current Zoom: ' + plugin._currentZoom);
			if (zoom !== 0) {
				//plugin._log("set zoom: " + zoom + ' ease:' + plugin._ease(1-zoom));
				progressbarDuration = plugin.options.maxZoom +
					(plugin._videoDuration - plugin.options.maxZoom) *
					plugin._ease(1 - zoom);
				if (startPos === undefined) {
					startPos = Math.max(0, plugin._currentPos - currentPosRatio * progressbarDuration);
				}
			} else {
				//plugin._log('fully zoomed out.')
			}
			var pointerPos = zoom * plugin._zoomControl.width();
			plugin._zoomControl.find(plugin._prefixClass('.pointer'))
				.css('left', pointerPos);
			plugin._zoomControl.find(plugin._prefixClass('.barFill'))
				.css('width', pointerPos + 'px');
			return plugin._updateInnerBar(startPos, progressbarDuration, true, playheadAlignment);

		},

		setBounds: function (startPos, duration) {
			var plugin = this,
				dfd = new $.Deferred(),
				zoom_ease, zoom;

			startPos = Math.max(startPos, 0);
			duration = Math.max(duration, plugin.options.maxZoom);
			zoom_ease = (duration - plugin.options.maxZoom) / (plugin._videoDuration - plugin.options.maxZoom);
			zoom = 1 - plugin._easeInvert(zoom_ease);
			if (plugin.isPlaying()) {
				plugin.element.one('pause', function () {
					plugin._log('set zoom');
					//setTimeout(function() {
					$.when(plugin.setZoom(zoom, startPos, 'hide')).done(function () {
						dfd.resolve();
					});
					//},10);
				});
				plugin.pause();
			} else {
				$.when(plugin.setZoom(zoom, startPos, 'hide')).done(function () {
					dfd.resolve();
				});
			}
			return dfd.promise();

		},

		zoomToClip: function () {
			var plugin = this,
				clipLength = plugin.options.outPoint - plugin.options.inPoint,
				duration = Math.max(clipLength, plugin.options.maxZoom),
				startPos = plugin.options.inPoint;

			if (clipLength < duration) {
				startPos -= (duration - clipLength) / 2;
			}

			// if (plugin._currentPos < plugin.options.inPoint || plugin._currentPos > plugin.options.outPoint) {
			// 	$.when(plugin.jumpToClip('in', 'left')).done(function () {
			// 		plugin.setBounds(startPos, duration);
			// 	});
			// } else {
			$.when(plugin.setBounds(startPos, duration)).done(function () {
				plugin._log('update clip display');
				plugin._updateClipDisplay();
			});
			//}
		},

		jumpToClip: function (which, alignPlayhead) {
			var plugin = this,
				point = null,
				dfd = new $.Deferred();
			switch (which) {
			case 'in':
				point = plugin.options.inPoint;
				alignPlayhead = alignPlayhead === undefined ? 'left' : alignPlayhead;

				break;
			case 'out':
				point = plugin.options.outPoint;
				alignPlayhead = alignPlayhead === undefined ? 'right' : alignPlayhead;
				break;
			}
			$.when(plugin.seek(point, plugin.isPlaying(), true, alignPlayhead)).done(function () {
				plugin._updateClipDisplay();
				dfd.resolve(true);
			});
			return dfd.promise();
		},

		setSpeed: function (speed) {
			var plugin = this,
				optionEl = plugin._speedControl.find('.option.speed_' + speed.text.replace('.', '_'));
			plugin._speedControl.find('.selection').text(speed.text);
			if (!optionEl.hasClass('selected')) {
				plugin._speedControl.find('.option').removeClass('selected');
				optionEl.addClass('selected');

			}
			plugin._videoPlayer.el.playbackRate = speed.value;
			$.each(plugin.options.availableSpeeds, function (index, availableSpeed) {
				plugin._speedControl.removeClass(availableSpeed.class);
			});
			plugin._speedControl.addClass(speed.class);
		},

		decreaseSpeed: function () {
			var plugin = this;
			var prevSpeed = plugin._speedControl.find('.selected').prev();
			if (prevSpeed.length) {
				// if (!plugin.isPlaying()) {
				// 	plugin.play();
				// }
				plugin.setSpeed(prevSpeed.data('speed'));
			} else {
				plugin.pause();
			}
		},

		increaseSpeed: function () {
			var plugin = this;
			var nextSpeed = plugin._speedControl.find('.selected').next();
			// if (!plugin.isPlaying()) {
			// 	plugin.play();
			// }
			if (nextSpeed.length) {
				plugin.setSpeed(nextSpeed.data('speed'));
			}
		},

		setNormalSpeed: function () {
			var plugin = this;
			$.each(plugin.options.availableSpeeds, function (index, availableSpeed) {
				if (availableSpeed.class == 'normal') {
					plugin.setSpeed(availableSpeed);
					return false;
				}
			});
		},

		showSpeedControl: function () {
			var plugin = this;
			plugin._clipBar.removeClass('hover');
			plugin._speedControl.find('.options').removeClass('hidden');
			plugin._doc.on('keydown.speed', function (e) {
				switch (e.keyCode) {
				case 38: //up
					plugin.decreaseSpeed();
					e.preventDefault();
					break;
				case 40: //down
					plugin.increaseSpeed();
					e.preventDefault();
					break;
				case 27: //escape
				case 13: //enter
					e.stopPropagation();
					plugin.hideSpeedControl();
					e.preventDefault();
					break;
				}
			});

		},

		hideSpeedControl: function () {
			var plugin = this;
			plugin._speedControl.find('.options').addClass('hidden');
			plugin._doc.off('keydown.speed');
		},

		toggleSpeedMode: function () {
			var plugin = this,
				volumeBar = plugin._volumeControl.find('.volumeBar');
			if (volumeBar.is(':visible')) {
				plugin.hideVolumeControl();
			}
			if (plugin._speedControl.find('.options').is(':visible')) {
				plugin.hideSpeedControl();
			} else {
				plugin.element.addClass(plugin._prefixClass('hover'));
				plugin.showSpeedControl();
			}
		},

		//level is a number between 0 and 1.
		setVolume: function (level) {
			var plugin = this;
			plugin._log('setvolume: ' + level);
			if (this.options.disableAudio) {
				return;
			}

			plugin._currentVolume = Number(level);
			if (level === 0) {
				if (!plugin._volumeControl.hasClass('muted')) {
					plugin.mute();
				}
				return;
			}
			if (plugin._volumeControl.hasClass('muted')) {
				this.mute(false);
			}
			switch (this._videoPlayer.type) {
			case 'html5':
				this._videoPlayer.el.volume = level;
				break;
			case 'flash':
				this._triggerPlayerEvent('setVolume', {
					level: level
				});
				break;
			}
			this._updateVolumeDisplay(level);
			this._trigger("setVolume", null, {
				value: level
			});
		},

		mute: function (mute) {
			var plugin = this;
			if ((!mute && plugin.options.disableAudio)) {
				return;
			}
			var muted;
			switch (plugin._videoPlayer.type) {
			case 'html5':
				plugin._videoPlayer.obj.prop('muted', mute === undefined ? this._videoPlayer.obj.prop(
						'muted') !==
					true : mute);

				muted = plugin._videoPlayer.obj.prop('muted');
				break;
			case 'flash':
				if (!plugin.videoIsLoaded()) {
					return;
				}
				if (mute === undefined) {
					mute = !plugin._videoPlayer.properties.muted;
				}
				plugin._triggerPlayerEvent('setVolume', {
					level: mute ? 0 : 0.5
				});
				plugin._videoPlayer.properties.muted = mute;
				muted = plugin._videoPlayer.properties.muted;
				break;
			}
			if (muted) {
				plugin._volumeControl.addClass('muted');
			} else {
				plugin._volumeControl.removeClass('muted');
			}
			this._trigger("mute", null, {
				value: muted
			});
			//this._updateVolumeDisplay(level);
		},

		toggleAudio: function (value) {
			this.options.disableAudio = value;
			this.mute(value);

		},

		showVolumeControl: function () {
			var plugin = this,
				volumeBar = plugin._volumeControl.find('.volumeBar');
			if (plugin.options.disableAudio) {
				return;
			}
			plugin._clipBar.removeClass('hover');
			volumeBar.show();
			if ($('.' + plugin._prefixClass('logDisplay')).is(':visible')) {
				volumeBar.css('z-index',
					$('.' + plugin._prefixClass('logDisplay'))
					.css('z-index') + 1);
			}
			plugin._doc.off('keydown.volume');
			plugin._doc.on('keydown.volume', function (e) {
				switch (e.keyCode) {
				case 38: //up
					plugin.increaseVolume();
					e.preventDefault();
					break;
				case 40: //down
					e.stopPropagation();
					plugin.decreaseVolume();
					e.preventDefault();
					break;
				case 27: //escape
				case 13: //enter
					plugin.hideVolumeControl();
					e.preventDefault();
					break;
				}
			});
		},

		hideVolumeControl: function (hidePlayerControls) {
			var plugin = this,
				volumeBar = plugin._volumeControl.find('.volumeBar');
			hidePlayerControls = hidePlayerControls === undefined ? true : hidePlayerControls;
			volumeBar.hide();
			if (hidePlayerControls) {
				plugin.element.removeClass(plugin._prefixClass('hover'));
				plugin._doc.off('keydown.volume');
			}
		},

		increaseVolume: function () {
			var plugin = this,
				multiplier = 1 / plugin.options.volumeIncrement,
				newVolume = Math.round(100 * (plugin._currentVolume + plugin.options.volumeIncrement)) /
				100;
			plugin.setVolume(Math.min(
				Math.floor(multiplier * newVolume) / multiplier, 1));
		},

		decreaseVolume: function () {
			var plugin = this,
				multiplier = 1 / plugin.options.volumeIncrement,
				newVolume = Math.max(0, plugin._currentVolume - plugin.options.volumeIncrement);
			newVolume = Math.round(100 * (newVolume)) / 100;
			plugin.setVolume(
				Math.max(Math.ceil(multiplier * newVolume) / multiplier, 0));
		},

		toggleVolumeMode: function () {
			var plugin = this,
				volumeBar = plugin._volumeControl.find('.volumeBar');
			if (plugin._speedControl.find('.options').is(':visible')) {
				plugin.hideSpeedControl();
			}
			if (volumeBar.is(':visible')) {
				plugin.hideVolumeControl();
			} else {
				plugin.element.addClass(plugin._prefixClass('hover'));
				plugin.showVolumeControl();
			}

		},

		setClip: function (inTime, outTime, suppressCallback) {
			var plugin = this;
			plugin._prevClip = {
				inPoint: plugin.options.inPoint,
				outPoint: plugin.options.outPoint
			};
			outTime = outTime == -1 ? plugin._videoDuration : outTime;
			plugin.options.inPoint = outTime == plugin.videoDuration ?
				Math.min(inTime, outTime - plugin.options.minClipLength) : inTime;
			plugin.options.outPoint = Math.max(outTime, plugin.options.inPoint + plugin.options.minClipLength);

			plugin._log(plugin.options.inPoint, plugin.options.outPoint);
			plugin._updateClipDisplay();
			// plugin.setIn(inTime, suppressCallback);
			// plugin.setOut(outTime, suppressCallback);
			// plugin._updateClipDisplay();
		},

		isPlaying: function () {
			if (this._videoPlayer) {
				switch (this._videoPlayer.type) {
				case 'html5':
					return !this._videoPlayer.el.paused;
				case 'flash':
					return this._videoPlayer.properties.isPlaying;
				}
			}
			return false;
		},

		play: function () {
			var plugin = this,
				currentPos;
			plugin._triggerPlayerEvent('play');
			this._togglePlayStateDisplay(true);

			//$('.statusText2').text('Play initiated.');
			plugin._toggleLoadingStateDisplay(true);
			if (plugin.options.thumbnailPreview && plugin._showingThumbnails) {
				currentPos = plugin._currentThumbnailPos;

				if (!plugin.videoIsLoaded()) {
					plugin._initialLoad = true;

					$.when(plugin._load(plugin.options, true, plugin._currentThumbnailPos)).done(function () {
						//plugin._log('loaded');
						//$('.statusText2').append('<br/>video loaded.');
						if (plugin._initialLoad) {

							if (currentPos) {
								plugin._initialSeek = true;
								plugin._seekPos = currentPos;
								//$('.statusText2').append('<br/>Play triggered.');
								plugin._triggerPlayerEvent('play');

							} else {
								plugin._initialSeek = false;
								plugin._initialLoad = false;
								//$('.statusText2').append('<br/>Play triggered (no seek).');
								plugin._triggerPlayerEvent('play');
							}
						} else {

							plugin._triggerPlayerEvent('play');
						}
					});
				} else {
					currentPos = plugin._currentThumbnailPos;
					plugin.seek(currentPos, true);
				}
			} else {
				plugin._triggerPlayerEvent('play');
			}
		},

		pause: function (updatePlaystate) {

			var plugin = this,
				dfd = new $.Deferred();
			if (updatePlaystate === undefined) {
				updatePlaystate = true;
			}
			if (!plugin.videoIsLoaded()) {
				return;
			}
			//setTimeout(function() {
			//	plugin._triggerPlayerEvent('pause', {userAction: userAction});
			//},1);
			$.when(plugin.getCurrentTime()).done(function (time) {
				plugin._updatePlayheadPosition(time);
				plugin._triggerPlayerEvent('pause', {
					'updatePlaystate': updatePlaystate
				});
				dfd.resolve();
			});
			return dfd.promise();
		},

		togglePlayState: function () {
			var plugin = this;

			if (plugin.isPlaying()) {
				plugin.pause();
				//plugin._addHoverState();
			} else {
				plugin.play();
				// console.trace();
				// console.log('start timeout');
				// plugin._hoverTimeout = setTimeout(function() {
				// 	console.log('remove hover state');
				// 	plugin.element.removeClass(plugin._prefixClass('hover'));
				// }, plugin.options.hoverTimeoutDuration);
			}
		},

		externalSeek: function (offset) {
			var plugin = this;
			var isPlaying = plugin.isPlaying();
			plugin.seek(offset, isPlaying);
			//plugin._updatePlayheadPosition(offset);
			// if (!plugin._videoIsLoaded) {

			// 	//plugin._toggleLoadingStateDisplay(false);
			// } else if (!plugin._showingThumbnails) {
			// 	plugin.seek(offset, isPlaying);

			// }
			/*if (play == undefined) {
        		play = pligin.isPlaying();
        	}

        	if (!plugin._videoPlayer.obj || plugin._videoPlayer.el.readyState == 0) {

        		if (plugin._showingThumbnails) {

					//this._showThumbnailPreview(offset);
					plugin._updatePlayheadPosition(offset);
					if ( play) {
						plugin.play();
					}

					return;
				} else {
					plugin._toggleLoadingStateDisplay(true);
					plugin._updatePlayheadPosition(plugin.options.inPoint);
					if ( play) {
						plugin.play();
					}

					return;
        		}
        	}
        	if (play && plugin._videoPlayer.type == 'html5') {
        		plugin._triggerPlayerEvent('play');
				setTimeout(function() {
					plugin.pause();
					plugin.seek(offset, play);
				}, 10);
        	} else {
        		plugin.seek(offset, play);
        	}*/
		},

		seek: function (offset, play, updatePlayheadPos, alignPlayhead) {
			var dfd = new $.Deferred(),
				playhead_dfd = new $.Deferred(),
				plugin = this,
				seekTimeout = null,
				attemptCount = 0,
				afterSeek = function () {
					if (!plugin._seeking) {
						dfd.resolve();
					}

					plugin._initialSeek = false;
					plugin._initialLoad = false;
					plugin._seeking = false;

					//it is not clear when you can play after seking
					//in ios 6. It seems like adding a delay here makes
					//playback work.
					if (play) {
						var count = 0,
							playInterval = null,
							alreadyPlaying = false;
						plugin._videoPlayer.obj.one('playing', function () {

							clearInterval(playInterval);
							alreadyPlaying = true;
							dfd.resolve();
						});

						plugin._triggerPlayerEvent('play');
						if (!alreadyPlaying) {
							playInterval = setInterval(function () {
								if (plugin._videoPlayer.el.paused) {
									plugin._triggerPlayerEvent('play');
									if (count > plugin._maxPlayIntervalCount) {
										clearInterval(playInterval);
										dfd.resolve();
									}
								} else {
									clearInterval(playInterval);
								}
								count++;
							}, 100);
						}

					} else {
						plugin.pause();
						dfd.resolve();
					}
				};
			if (plugin._seeking) {
				console.log('already seeking so doing nothing.');
				dfd.resolve();
				return;
			}

			updatePlayheadPos = updatePlayheadPos === undefined ? true : updatePlayheadPos;
			alignPlayhead = alignPlayhead === undefined ? 'center' : alignPlayhead;

			plugin._seeking = true;
			console.log('starting seek.')
			if (play === undefined) {
				play = plugin.isPlaying();
			}

			if (!plugin.videoIsLoaded()) {

				if (plugin._showingThumbnails) {
					plugin._showThumbnailPreview(offset, updatePlayheadPos);
					if (updatePlayheadPos) {
						$.when(plugin._updatePlayheadPosition(offset, false, alignPlayhead)).done(function () {
							playhead_dfd.resolve();
						});
					} else {
						playhead_dfd.resolve();
					}
				} else {

					plugin._toggleLoadingStateDisplay(true);
					if (updatePlayheadPos) {
						$.when(plugin._updatePlayheadPosition(plugin.options.inPoint, false, alignPlayhead)).done(
							function () {
								playhead_dfd.resolve();
							});
					} else {
						playhead_dfd.resolve();
					}
				}
				if (play) {
					plugin.play();
				}

			} else {

				if (plugin._videoPlayer) {
					//Always show thumbnails when not playing because browsers
					//are inaccurate when reporting bufferd data.
					if (!play /*&& !plugin._isBuffered(offset)*/ ) {
						plugin._showThumbnailPreview(offset, updatePlayheadPos);
						if (updatePlayheadPos) {
							$.when(plugin._updatePlayheadPosition(offset, false, alignPlayhead)).done(function () {
								playhead_dfd.resolve();
							});
						} else {
							playhead_dfd.resolve();
						}

					} else {
						playhead_dfd.resolve();
					}
				}
			}
			$.when(playhead_dfd).done(function () {

				if (!plugin.videoIsLoaded() || !play) {
					plugin._seeking = false;
					dfd.resolve();
				} else if (plugin.videoIsLoaded() && plugin._videoPlayer) {
					plugin._toggleLoadingStateDisplay(true);
					switch (plugin._videoPlayer.type) {
					case 'html5':

						//no seek is needed
						if (plugin._videoPlayer.el.currentTime == offset) {
							afterSeek();
						}
						//$('.statusText2').append('<br/>Paused.');
						plugin.pause(false /*don't update play state*/ );

						plugin._toggleLoadingStateDisplay(true);

						plugin._videoPlayer.obj.one('seeked', function () {
							//$('.statusText2').append('<br/>seeked event.');
							if (plugin._seeking) {
								clearInterval(seekTimeout);
								afterSeek();
							}
						});

						//Actulay seek
						plugin._videoPlayer.el.currentTime = offset;

						if (plugin._initialSeek) {

							seekTimeout = setInterval(function () {
								if (plugin._seeking) {
									//firefox doesn't fire the seeked event on the initial seek
									//so check the position,
									//plugin._log(plugin._videoPlayer.el.currentTime + ' ' + offset);
									if (plugin._videoPlayer.el.currentTime == offset) {
										//$('.statusText2').append('<br/>At correct position.');
										clearInterval(seekTimeout);
										afterSeek();
									} else if (attemptCount > plugin._maxPlayIntervalCount) {
										//$('.statusText2').append('<br/>max Interval count.');
										clearInterval(seekTimeout);
										afterSeek();
									} else {
										plugin._videoPlayer.el.currentTime = offset;
									}
								} else {
									//plugin._log('not seeking');
									clearInterval(seekTimeout);
								}
								attemptCount++;
							}, 200);
						}

						break;
					case 'flash':
						plugin._videoPlayer.obj.flash(function () {
							plugin._seeking = false;
							if (play) {

								if (offset !== undefined) {
									this.playVideo(Math.floor(offset));
								} else {
									this.playVideo(Math.floor(plugin._currentPos));
								}
							} else {
								this.seek(Math.floor(offset));
							}
						});
						break;
					}

				}
			});
			return dfd.promise();
		},

		step: function (amount) {
			var plugin = this,
				wasPlaying = plugin.isPlaying();

			$.when(plugin.getCurrentTime()).done(function (offset) {
				$.when(plugin.seek(offset + amount, false)).done(function () {
					if (wasPlaying) {
						plugin.element.one('pause', function () {
							plugin.play();
						});
						plugin.pause();
					}
				});
			});
		},

		seekTimecode: function (timecode, play) {
			var plugin = this;
			var offset = this.options.getOffset(this.options.startOffset, timecode, this.options.fps);
			offset += this.options.startOffset - Math.floor(this.options.startOffset);

			play = play === undefined ? false : play;

			if (offset > this._videoDuration) {
				offset = this._videoDuration;
				timecode = this.options.getTimecode(this.options.startOffset, offset, this.options.fps,
					true);
				this._updateTimecodeTextField('currentPos', timecode, true /*force update*/ );
			} else if (offset < 0) {
				offset = 0;
				timecode = this.options.getTimecode(this.options.startOffset, offset, this.options.fps);
				this._updateTimecodeTextField('currentPos', timecode, true /*force update*/ );
			}
			//plugin._log('seek: ' + offset);
			$.when(this.seek(offset)).done(function () {
				plugin._updatePlayheadPosition(offset, true);
				if (play) {
					plugin.play();
				}
			});
		},

		getCurrentTime: function (forceRealPlayerPos) {
			var plugin = this;
			if (forceRealPlayerPos === undefined) {
				forceRealPlayerPos = false;
			}

			var dfd = new $.Deferred();
			if (!plugin._showingVideo) {
				dfd.resolve(0);
			}
			if (plugin._showingThumbnails && (!plugin.videoIsLoaded() || !forceRealPlayerPos)) {
				dfd.resolve(plugin._currentThumbnailPos);
			} else if (!plugin.videoIsLoaded()) {
				dfd.resolve(0);
			} else {
				switch (plugin._videoPlayer.type) {
				case 'html5':
					dfd.resolve(plugin._videoPlayer.el.currentTime);
					break;
				case 'flash':
					plugin._statusDeferred = new $.Deferred();
					plugin._triggerPlayerEvent('status');
					$.when(plugin._statusDeferred).done(function (data) {
						 plugin._statusDeferred = null;
						if (!data) {
							dfd.resolve(plugin._currentPos);
						} else {
							dfd.resolve(data.time);
						}
					});
					break;
				}
			}
			return dfd.promise();
		},

		toggleFullScreen: function (setToFullScreen) {
			var plugin = this,
				resizeTimeout_fs = null,
				setFullscreenSize;
			var currentStatus = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen ||
				document.msFullscreenElement || false;

			//if the status is already correct, make the plugin state reflect it.
			if (setToFullScreen !== undefined && currentStatus == setToFullScreen) {
				if (currentStatus) {

					if (!plugin.element.hasClass(plugin._prefixClass('fullScreen'))) {
						plugin.element.addClass(plugin._prefixClass('fullScreen'));
						plugin._trigger('setFullscreen', null, {
							value: true
						});
					}
				} else {
					if (plugin.element.hasClass(plugin._prefixClass('fullScreen'))) {
						plugin.element.removeClass(plugin._prefixClass('fullScreen'));
						plugin._trigger('setFullscreen', null, {
							value: false
						});
					}
				}
				return;
			}

			setToFullScreen = !currentStatus;

			if (setToFullScreen) {
				//listen for the fullscreen close event (i.e. the user pressing escape)
				plugin._doc.on(
					"fullscreenchange mozfullscreenchange webkitfullscreenchange MSFullscreenChange",
					function () {

						var currentStatus = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen ||
							document.msFullscreenElement || false;

						//exiting fullscreen
						if (!currentStatus) {
							plugin._doc.off(
								"fullscreenchange mozfullscreenchange webkitfullscreenchange MSFullscreenChange");
							clearTimeout(resizeTimeout_fs);
							$(window).off('resize.fullscreen');
							plugin.element.find('.' + plugin._prefixClass('player-widget')).css({
								'width': '',
								'margin-top': ''
							});
							plugin.element.css({
								'width': '',
								'height': '',
							});
							plugin.element.find('.tcField').off('.fullscreenFocus');
							plugin.toggleFullScreen(false);
							plugin._updateInnerBar(plugin._progressBarStartPos);
							plugin.setZoom(plugin._currentZoom);
							//plugin.element.css('fontSize','16px'); /* YAY! MAGIC NUMBER! */

							//entering fullscreen
						} else {
							setFullscreenSize();
							//correctThumbnailPos();

							$(window).on('resize.fullscreen', function () {
								clearTimeout(resizeTimeout_fs);
								resizeTimeout_fs = setTimeout(function () {
									setFullscreenSize();
									//correctThumbnailPos();
									plugin._updateInnerBar(plugin._progressBarStartPos);
									plugin.setZoom(plugin._currentZoom);
								}, 1);
							});
						}

					});
				plugin.element.addClass(plugin._prefixClass('fullScreen'));
				var element = plugin.element[0];
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.mozRequestFullscreen) {
					element.mozRequestFullscreen();
				} else if (element.msRequestFullscreen) {
					element.msRequestFullscreen();

				} else if (element.webkitRequestFullscreen) {
					element.webkitRequestFullscreen();
					//safari 5.1	(note the captial S)
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				}

				setFullscreenSize = function () {
					var pageHeight = verge.viewportH(); //Math.max(verge.viewportH(), 480);
					var pageWidth = verge.viewportW(); //Math.max(verge.viewportW(), 450);

					var videoHeight = (pageHeight - 217); /* 217 = height of controls (150px) + height of minilog (42px) + some margin (25px) */
					var videoWidth = Math.min(pageWidth, (videoHeight / plugin.options.aspectRatio));

					//don't push the margin past the bottom of the minilog, so all text fields
					//will remain visible.
					var margin = Math.min(pageHeight - verge.viewportH(), videoHeight + 42);
					plugin.element.find('.' + plugin._prefixClass('player-widget')).css({
						'width': videoWidth + 'px'
							//'margin-top': margin  > 0 ? '-' + margin + 'px' :''
					});
					plugin.element.css({
						'width': pageWidth + 'px',
						'height': pageHeight + 'px'
					});
				};

				plugin._trigger('setFullscreen', null, {
					value: true
				});
			} else {
				plugin.element.removeClass(plugin._prefixClass('fullScreen'));
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
					//safari 5.1	(note the captial S)
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				}
				/*
				plugin.element.css({
					fontSize: '',
					//manually size the background image because safari gets background-size contain wrong
					'background-size': ''
				});
				*/
				plugin._trigger('setFullscreen', null, {
					value: false
				});
			}
		},

		flashListener: function (params) {
			var plugin = this;
			var currentTime = new Date();
			var optionsObj = {};
			plugin._log(params);
			
			if (params.options) {
				optionsObj = $.parseJSON(params.options);
			}
			switch (params.command) {
				//case 'playEnd': alert('end!'); break;
			case 'playStart':
				plugin._playbackStarted = true;
				plugin._videoPlayer.properties.isPlaying = true;
				plugin._togglePlayStateDisplay(plugin._videoPlayer.properties.isPlaying);
				plugin._hideThumbnailPreview();
				plugin._trigger("play", null, {});
				break;
			case 'playStop':
				plugin._videoPlayer.properties.isPlaying = false;
				plugin._togglePlayStateDisplay(plugin._videoPlayer.properties.isPlaying);
				plugin._trigger("pause", null, {});
				break;
			case 'playEnd':
				plugin._videoPlayer.properties.isPlaying = false;
				plugin._togglePlayStateDisplay(false);
				plugin._trigger('playEnd');
				break;
			case 'setVolume':
				$.cookie('playerVolume', optionsObj.volume, {
					expires: HF_GLOBALS.volumeCookieLifetime
				});
				if (optionsObj.volume === 0) {
					$.cookie('maualMute', 'true');
				} else {
					$.cookie('maualMute', null);
				}
				plugin._updateVolumeDisplay(optionsObj.volume);
				plugin._trigger('setvolume', null, optionsObj.volume);
				break;
			case 'setLockedToLog':
				plugin._trigger("setLockedToLog", null, {
					value: optionsObj.lockedToLog
				});
				break;
			case 'setFullscreenMode':
				plugin._trigger("setFullscreen", null, {
					value: optionsObj.fullscreen
				});
				break;
			case 'location':
				plugin._updatePlayheadPosition(optionsObj.time);

				break;
			case 'bufferStatus':
				plugin._updateBufferedDisplay(optionsObj);
				break;
			case 'status':
				if (Number(optionsObj.duration) !== 0 && plugin._flashLoadFinishedDfd) {
					plugin._flashLoadFinishedDfd.resolve();
				}
				if (plugin._playbackStarted) {
					plugin._updatePlayheadPosition(optionsObj.time);
					plugin._videoDuration = optionsObj.duration;
					if (plugin.options.outPoint > plugin._videoDuration) {
						plugin.options.outPoint = plugin._videoDuration;
					}
					if (plugin._videoDuration <= plugin.options.maxZoom) {
						plugin.element.addClass('disableZoom');
					} else {
						plugin.element.removeClass('disableZoom');
					}

					if (plugin._statusDeferred) {
						plugin._statusDeferred.resolve(optionsObj);
					}
					plugin._trigger('updateStatus', null, optionsObj);
				} else {
					plugin._statusDeferred.resolve(null);
				}
				//plugin._trigger('updateStatus', null, optionsObj);
				break;
			case 'error':
				plugin._trigger("error", null, {
					value: optionsObj
				});
				break;
			}

		},

		resize: function() {
			// let plugin = this;
			// plugin._log('player resize');
			// if (plugin._showingThumbnails) {
			// 	plugin._showThumbnailPreview(plugin._currentPos);
			// }
			// plugin._updateClipDisplay();
		},

		// Respond to any changes the user makes to the
		// option method
		_setOption: function (key, value) {
			switch (key) {
			case "inPoint":
				this.setIn(value);
				break;
			case "outPoint":
				this.setOut(value);
				break;
			case "disableClipTrimming":
				this.toggleClipTrimming(value);
				break;
			case "showClipControls":
				this.toggleClipControls(value);
				break;
			case "disableAudio":
				this.toggleAudio(value);
				break;
			}

			//store the option
			this._super("_setOption", key, value);
		}
	});

})(jQuery, window, document);
